(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-final-chapter-cherry-blossom"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const focusableSelector = 'a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

    function hydrateTriggerMenus(root) {
      root.acFinalTriggerCleanup = root.acFinalTriggerCleanup || [];
      root.querySelectorAll('[data-ac-final-trigger-readable]').forEach((menu) => {
        if (menu.dataset.acFinalTriggerReady === 'true') return;

        const source = document.getElementById(menu.dataset.sourceId);
        if (!source) return;

        let rawText = '';
        try {
          rawText = JSON.parse(source.textContent);
        } catch (error) {
          rawText = source.textContent.trim();
        }

        const groups = String(rawText)
          .trim()
          .split(/\r?\n\s*\r?\n/)
          .map((group) => group.trim())
          .filter(Boolean);

        const fragment = document.createDocumentFragment();

        const mobileQuery = window.matchMedia('(max-width: 760px)');

        groups.forEach((groupText, groupIndex) => {
          const separator = groupText.indexOf(':');
          if (separator < 0) return;

          const heading = groupText.slice(0, separator).trim();
          const items = groupText
            .slice(separator + 1)
            .split(';')
            .map((item) => item.trim().replace(/\.\s*$/, ''))
            .filter(Boolean);

          if (!heading || !items.length) return;

          const group = document.createElement('details');
          group.className = 'ac-final__trigger-group';
          group.open = !mobileQuery.matches || groupIndex === 0;

          const summary = document.createElement('summary');
          summary.addEventListener('click', (event) => {
            event.preventDefault();
            if (mobileQuery.matches) group.open = !group.open;
          });

          const title = document.createElement('h4');
          title.textContent = heading;
          summary.appendChild(title);
          group.appendChild(summary);

          const list = document.createElement('ul');
          items.forEach((itemText) => {
            const item = document.createElement('li');
            item.textContent = itemText;
            list.appendChild(item);
          });
          group.appendChild(list);

          fragment.appendChild(group);
        });

        if (fragment.childNodes.length) {
          menu.replaceChildren(fragment);
          menu.dataset.acFinalTriggerReady = 'true';

          const syncMenuMode = (event) => {
            const menuGroups = Array.from(menu.querySelectorAll('.ac-final__trigger-group'));
            if (event.matches) {
              const openGroup = menuGroups.find((group) => group.open) || menuGroups[0];
              menuGroups.forEach((group) => { group.open = group === openGroup; });
            } else {
              menuGroups.forEach((group) => { group.open = true; });
            }
          };

          if (mobileQuery.addEventListener) {
            mobileQuery.addEventListener('change', syncMenuMode);
            root.acFinalTriggerCleanup.push(() => mobileQuery.removeEventListener('change', syncMenuMode));
          }
        }
      });
    }

    function initialize(root) {
      if (!root || root.dataset.acFinalReady === 'true') return;
      root.dataset.acFinalReady = 'true';
      hydrateTriggerMenus(root);

      const layer = root.querySelector('[data-ac-final-layer]');
      const panels = Array.from(root.querySelectorAll('[data-ac-final-panel]'));
      const openers = Array.from(root.querySelectorAll('[data-ac-final-open]'));
      let activeOpener = null;

      function setDocumentLock(locked) {
        document.documentElement.classList.toggle('ac-final-lock', locked);
      }

      function closeDetail() {
        if (!layer || layer.hidden) return;
        layer.hidden = true;
        panels.forEach((panel) => { panel.hidden = true; });
        setDocumentLock(false);
        if (activeOpener && document.contains(activeOpener)) activeOpener.focus();
        activeOpener = null;
      }

      function openDetail(opener) {
        if (!layer || !opener) return;
        const panelId = opener.dataset.acFinalOpen;
        const activePanel = panels.find((panel) => panel.dataset.acFinalPanel === panelId);
        if (!activePanel) return;

        activeOpener = opener;
        panels.forEach((panel) => { panel.hidden = panel !== activePanel; });
        layer.hidden = false;
        layer.scrollTop = 0;
        activePanel.scrollTop = 0;
        setDocumentLock(true);
        const close = activePanel.querySelector('[data-ac-final-close]');
        if (close) close.focus();
      }

      openers.forEach((opener) => {
        opener.addEventListener('click', () => openDetail(opener));
      });

      root.querySelectorAll('[data-ac-final-close]').forEach((button) => {
        button.addEventListener('click', closeDetail);
      });

      if (layer) {
        layer.addEventListener('click', (event) => {
          if (event.target === layer) closeDetail();
        });
      }

      root.addEventListener('keydown', (event) => {
        if (!layer || layer.hidden) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDetail();
          return;
        }
        if (event.key !== 'Tab') return;

        const activePanel = panels.find((panel) => !panel.hidden);
        if (!activePanel) return;
        const focusable = Array.from(activePanel.querySelectorAll(focusableSelector));
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      const purchaseButton = root.querySelector('[data-ac-final-purchase]');
      if (purchaseButton) {
        purchaseButton.addEventListener('click', (event) => {
          const selector = root.dataset.purchaseSelector.trim() || '#offer-card, [data-ac-pwyw]';
          let target = null;
          try {
            target = document.querySelector(selector);
          } catch (error) {
            target = document.querySelector('#offer-card, [data-ac-pwyw]');
          }
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
          const firstChoice = target.querySelector('button, a[href], input, select');
          if (firstChoice) window.setTimeout(() => firstChoice.focus({ preventScroll: true }), 500);
        });
      }

      root.addEventListener('shopify:block:select', (event) => {
        const opener = root.querySelector(`[data-ac-final-open="${event.detail.blockId}"]`);
        if (opener) openDetail(opener);
      });

      root.addEventListener('shopify:block:deselect', closeDetail);
      root.acFinalDestroy = () => {
        setDocumentLock(false);
        (root.acFinalTriggerCleanup || []).forEach((cleanup) => cleanup());
      };
    }

    document.querySelectorAll('[data-ac-final]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-ac-final]') ? event.target : event.target.querySelector('[data-ac-final]');
      initialize(root);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches('[data-ac-final]') ? event.target : event.target.querySelector('[data-ac-final]');
      if (root && root.acFinalDestroy) root.acFinalDestroy();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac-final-chapter-gothic"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const focusableSelector = 'a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

    function hydrateTriggerMenus(root) {
      root.acFinalTriggerCleanup = root.acFinalTriggerCleanup || [];
      root.querySelectorAll('[data-ac-final-trigger-readable]').forEach((menu) => {
        if (menu.dataset.acFinalTriggerReady === 'true') return;

        const source = document.getElementById(menu.dataset.sourceId);
        if (!source) return;

        let rawText = '';
        try {
          rawText = JSON.parse(source.textContent);
        } catch (error) {
          rawText = source.textContent.trim();
        }

        const groups = String(rawText)
          .trim()
          .split(/\r?\n\s*\r?\n/)
          .map((group) => group.trim())
          .filter(Boolean);

        const fragment = document.createDocumentFragment();

        const mobileQuery = window.matchMedia('(max-width: 760px)');

        groups.forEach((groupText, groupIndex) => {
          const separator = groupText.indexOf(':');
          if (separator < 0) return;

          const heading = groupText.slice(0, separator).trim();
          const items = groupText
            .slice(separator + 1)
            .split(';')
            .map((item) => item.trim().replace(/\.\s*$/, ''))
            .filter(Boolean);

          if (!heading || !items.length) return;

          const group = document.createElement('details');
          group.className = 'ac-final__trigger-group';
          group.open = !mobileQuery.matches || groupIndex === 0;

          const summary = document.createElement('summary');
          summary.addEventListener('click', (event) => {
            event.preventDefault();
            if (mobileQuery.matches) group.open = !group.open;
          });

          const title = document.createElement('h4');
          title.textContent = heading;
          summary.appendChild(title);
          group.appendChild(summary);

          const list = document.createElement('ul');
          items.forEach((itemText) => {
            const item = document.createElement('li');
            item.textContent = itemText;
            list.appendChild(item);
          });
          group.appendChild(list);

          fragment.appendChild(group);
        });

        if (fragment.childNodes.length) {
          menu.replaceChildren(fragment);
          menu.dataset.acFinalTriggerReady = 'true';

          const syncMenuMode = (event) => {
            const menuGroups = Array.from(menu.querySelectorAll('.ac-final__trigger-group'));
            if (event.matches) {
              const openGroup = menuGroups.find((group) => group.open) || menuGroups[0];
              menuGroups.forEach((group) => { group.open = group === openGroup; });
            } else {
              menuGroups.forEach((group) => { group.open = true; });
            }
          };

          if (mobileQuery.addEventListener) {
            mobileQuery.addEventListener('change', syncMenuMode);
            root.acFinalTriggerCleanup.push(() => mobileQuery.removeEventListener('change', syncMenuMode));
          }
        }
      });
    }

    function initialize(root) {
      if (!root || root.dataset.acFinalReady === 'true') return;
      root.dataset.acFinalReady = 'true';
      hydrateTriggerMenus(root);

      const layer = root.querySelector('[data-ac-final-layer]');
      const panels = Array.from(root.querySelectorAll('[data-ac-final-panel]'));
      const openers = Array.from(root.querySelectorAll('[data-ac-final-open]'));
      let activeOpener = null;

      function setDocumentLock(locked) {
        document.documentElement.classList.toggle('ac-final-lock', locked);
      }

      function closeDetail() {
        if (!layer || layer.hidden) return;
        layer.hidden = true;
        panels.forEach((panel) => { panel.hidden = true; });
        setDocumentLock(false);
        if (activeOpener && document.contains(activeOpener)) activeOpener.focus();
        activeOpener = null;
      }

      function openDetail(opener) {
        if (!layer || !opener) return;
        const panelId = opener.dataset.acFinalOpen;
        const activePanel = panels.find((panel) => panel.dataset.acFinalPanel === panelId);
        if (!activePanel) return;

        activeOpener = opener;
        panels.forEach((panel) => { panel.hidden = panel !== activePanel; });
        layer.hidden = false;
        layer.scrollTop = 0;
        activePanel.scrollTop = 0;
        setDocumentLock(true);
        const close = activePanel.querySelector('[data-ac-final-close]');
        if (close) close.focus();
      }

      openers.forEach((opener) => {
        opener.addEventListener('click', () => openDetail(opener));
      });

      root.querySelectorAll('[data-ac-final-close]').forEach((button) => {
        button.addEventListener('click', closeDetail);
      });

      if (layer) {
        layer.addEventListener('click', (event) => {
          if (event.target === layer) closeDetail();
        });
      }

      root.addEventListener('keydown', (event) => {
        if (!layer || layer.hidden) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDetail();
          return;
        }
        if (event.key !== 'Tab') return;

        const activePanel = panels.find((panel) => !panel.hidden);
        if (!activePanel) return;
        const focusable = Array.from(activePanel.querySelectorAll(focusableSelector));
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      const purchaseButton = root.querySelector('[data-ac-final-purchase]');
      if (purchaseButton) {
        purchaseButton.addEventListener('click', (event) => {
          const selector = root.dataset.purchaseSelector.trim() || '#offer-card, [data-ac-pwyw]';
          let target = null;
          try {
            target = document.querySelector(selector);
          } catch (error) {
            target = document.querySelector('#offer-card, [data-ac-pwyw]');
          }
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
          const firstChoice = target.querySelector('button, a[href], input, select');
          if (firstChoice) window.setTimeout(() => firstChoice.focus({ preventScroll: true }), 500);
        });
      }

      root.addEventListener('shopify:block:select', (event) => {
        const opener = root.querySelector(`[data-ac-final-open="${event.detail.blockId}"]`);
        if (opener) openDetail(opener);
      });

      root.addEventListener('shopify:block:deselect', closeDetail);
      root.acFinalDestroy = () => {
        setDocumentLock(false);
        (root.acFinalTriggerCleanup || []).forEach((cleanup) => cleanup());
      };
    }

    document.querySelectorAll('[data-ac-final]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-ac-final]') ? event.target : event.target.querySelector('[data-ac-final]');
      initialize(root);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches('[data-ac-final]') ? event.target : event.target.querySelector('[data-ac-final]');
      if (root && root.acFinalDestroy) root.acFinalDestroy();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac-final-chapter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const focusableSelector = 'a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

    function hydrateTriggerMenus(root) {
      root.acFinalTriggerCleanup = root.acFinalTriggerCleanup || [];
      root.querySelectorAll('[data-ac-final-trigger-readable]').forEach((menu) => {
        if (menu.dataset.acFinalTriggerReady === 'true') return;

        const source = document.getElementById(menu.dataset.sourceId);
        if (!source) return;

        let rawText = '';
        try {
          rawText = JSON.parse(source.textContent);
        } catch (error) {
          rawText = source.textContent.trim();
        }

        const groups = String(rawText)
          .trim()
          .split(/\r?\n\s*\r?\n/)
          .map((group) => group.trim())
          .filter(Boolean);

        const fragment = document.createDocumentFragment();

        const mobileQuery = window.matchMedia('(max-width: 760px)');

        groups.forEach((groupText, groupIndex) => {
          const separator = groupText.indexOf(':');
          if (separator < 0) return;

          const heading = groupText.slice(0, separator).trim();
          const items = groupText
            .slice(separator + 1)
            .split(';')
            .map((item) => item.trim().replace(/\.\s*$/, ''))
            .filter(Boolean);

          if (!heading || !items.length) return;

          const group = document.createElement('details');
          group.className = 'ac-final__trigger-group';
          group.open = !mobileQuery.matches || groupIndex === 0;

          const summary = document.createElement('summary');
          summary.addEventListener('click', (event) => {
            event.preventDefault();
            if (mobileQuery.matches) group.open = !group.open;
          });

          const title = document.createElement('h4');
          title.textContent = heading;
          summary.appendChild(title);
          group.appendChild(summary);

          const list = document.createElement('ul');
          items.forEach((itemText) => {
            const item = document.createElement('li');
            item.textContent = itemText;
            list.appendChild(item);
          });
          group.appendChild(list);

          fragment.appendChild(group);
        });

        if (fragment.childNodes.length) {
          menu.replaceChildren(fragment);
          menu.dataset.acFinalTriggerReady = 'true';

          const syncMenuMode = (event) => {
            const menuGroups = Array.from(menu.querySelectorAll('.ac-final__trigger-group'));
            if (event.matches) {
              const openGroup = menuGroups.find((group) => group.open) || menuGroups[0];
              menuGroups.forEach((group) => { group.open = group === openGroup; });
            } else {
              menuGroups.forEach((group) => { group.open = true; });
            }
          };

          if (mobileQuery.addEventListener) {
            mobileQuery.addEventListener('change', syncMenuMode);
            root.acFinalTriggerCleanup.push(() => mobileQuery.removeEventListener('change', syncMenuMode));
          }
        }
      });
    }

    function initialize(root) {
      if (!root || root.dataset.acFinalReady === 'true') return;
      root.dataset.acFinalReady = 'true';
      hydrateTriggerMenus(root);

      const layer = root.querySelector('[data-ac-final-layer]');
      const panels = Array.from(root.querySelectorAll('[data-ac-final-panel]'));
      const openers = Array.from(root.querySelectorAll('[data-ac-final-open]'));
      let activeOpener = null;

      function setDocumentLock(locked) {
        document.documentElement.classList.toggle('ac-final-lock', locked);
      }

      function closeDetail() {
        if (!layer || layer.hidden) return;
        layer.hidden = true;
        panels.forEach((panel) => { panel.hidden = true; });
        setDocumentLock(false);
        if (activeOpener && document.contains(activeOpener)) activeOpener.focus();
        activeOpener = null;
      }

      function openDetail(opener) {
        if (!layer || !opener) return;
        const panelId = opener.dataset.acFinalOpen;
        const activePanel = panels.find((panel) => panel.dataset.acFinalPanel === panelId);
        if (!activePanel) return;

        activeOpener = opener;
        panels.forEach((panel) => { panel.hidden = panel !== activePanel; });
        layer.hidden = false;
        layer.scrollTop = 0;
        activePanel.scrollTop = 0;
        setDocumentLock(true);
        const close = activePanel.querySelector('[data-ac-final-close]');
        if (close) close.focus();
      }

      openers.forEach((opener) => {
        opener.addEventListener('click', () => openDetail(opener));
      });

      root.querySelectorAll('[data-ac-final-close]').forEach((button) => {
        button.addEventListener('click', closeDetail);
      });

      if (layer) {
        layer.addEventListener('click', (event) => {
          if (event.target === layer) closeDetail();
        });
      }

      root.addEventListener('keydown', (event) => {
        if (!layer || layer.hidden) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDetail();
          return;
        }
        if (event.key !== 'Tab') return;

        const activePanel = panels.find((panel) => !panel.hidden);
        if (!activePanel) return;
        const focusable = Array.from(activePanel.querySelectorAll(focusableSelector));
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      const purchaseButton = root.querySelector('[data-ac-final-purchase]');
      if (purchaseButton) {
        purchaseButton.addEventListener('click', (event) => {
          const selector = root.dataset.purchaseSelector.trim() || '#offer-card, [data-ac-pwyw]';
          let target = null;
          try {
            target = document.querySelector(selector);
          } catch (error) {
            target = document.querySelector('#offer-card, [data-ac-pwyw]');
          }
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
          const firstChoice = target.querySelector('button, a[href], input, select');
          if (firstChoice) window.setTimeout(() => firstChoice.focus({ preventScroll: true }), 500);
        });
      }

      root.addEventListener('shopify:block:select', (event) => {
        const opener = root.querySelector(`[data-ac-final-open="${event.detail.blockId}"]`);
        if (opener) openDetail(opener);
      });

      root.addEventListener('shopify:block:deselect', closeDetail);
      root.acFinalDestroy = () => {
        setDocumentLock(false);
        (root.acFinalTriggerCleanup || []).forEach((cleanup) => cleanup());
      };
    }

    document.querySelectorAll('[data-ac-final]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-ac-final]') ? event.target : event.target.querySelector('[data-ac-final]');
      initialize(root);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches('[data-ac-final]') ? event.target : event.target.querySelector('[data-ac-final]');
      if (root && root.acFinalDestroy) root.acFinalDestroy();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac-pwyw-desktop-blossom"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-ac-pwyw-desktop]';

    function money(cents, currency) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(cents / 100);
    }

    function parseMoneyToCents(rawValue) {
      const cleaned = String(rawValue || '').trim().replace(/[$\s]/g, '').replace(',', '.');
      if (!/^\d+(?:\.\d{0,2})?$/.test(cleaned)) return null;
      const parts = cleaned.split('.');
      const whole = Number(parts[0]);
      const fraction = Number((parts[1] || '').padEnd(2, '0'));
      if (!Number.isSafeInteger(whole) || whole < 0) return null;
      return (whole * 100) + fraction;
    }

    function groupId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return `pwyw-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }

    function initialize(root) {
      if (window.matchMedia('(max-width:749px)').matches) return;
      if (!root || root.dataset.acPwyw2Ready === 'true') return;

      const configNode = root.querySelector('[data-ac-pwyw-desktop-config]');
      if (!configNode) return;

      let config;
      try {
        config = JSON.parse(configNode.textContent);
      } catch (error) {
        const visibleStatus = root.querySelector('[data-ac-role="status"]');
        if (visibleStatus) {
          visibleStatus.textContent = 'The offer configuration could not load. Please contact the store owner.';
        }
        root.querySelectorAll('button').forEach((button) => {
          button.disabled = true;
        });
        console.error('AC PWYW configuration error:', error);
        return;
      }
      root.dataset.acPwyw2Ready = 'true';

      const get = (role) => root.querySelector(`[data-ac-role="${role}"]`);
      const formatButtons = Array.from(root.querySelectorAll('[data-ac-format]'));
      const formatEntryButtons = Array.from(root.querySelectorAll('[data-ac2-format]'));
      const detailTitle = root.querySelector('[data-ac2-detail-title]');
      const backButton = root.querySelector('[data-ac2-back]');
      const mobilePrice = root.querySelector('[data-ac2-price]');
      const mobileMinimum = root.querySelector('[data-ac2-minimum]');
      const changeFormatButton = root.querySelector('[data-ac2-change-format]');
      const formatSummary = root.querySelector('[data-ac2-format-name]');
      const desktopStep = root.querySelector('[data-ac2-desktop-step]');
      const desktopCopy = root.querySelector('[data-ac2-desktop-copy]');
      const desktopAudio = root.querySelector('[data-ac2-desktop-audio]');
      const giftPanel = root.querySelector('[data-ac2-gift]');
      const giftButtons = Array.from(root.querySelectorAll('[data-ac2-gift-option]'));
      let selectedGift = null;
      const mobileRetail = root.querySelector('[data-ac2-retail]');
      const mobileError = root.querySelector('[data-ac2-error]');
      const mobileClaim = root.querySelector('[data-ac2-claim]');
      const mobileStatus = root.querySelector('[data-ac2-status]');
      const mobileMenu = document.querySelector('.item__mobile--hamburger > .mobileMenu-toggle');
      const mobileCopy = JSON.parse(root.querySelector('[data-ac2-copy]').textContent);

      const priceButtons = Array.from(root.querySelectorAll('[data-ac-price-choice]'));
      const vaultItems = Array.from(root.querySelectorAll('[data-ac-vault-item]'));
      const vaultNodes = Array.from(root.querySelectorAll('[data-ac-vault-node]'));
      const vaultTicks = Array.from(root.querySelectorAll('[data-ac-vault-tick]'));
      const title = get('title');
      const eyebrow = get('eyebrow');
      const description = get('description');
      const productImage = get('product-image');
      const retailPrice = get('retail-price');
      const customCard = root.querySelector('[data-ac-custom-card]');
      const customInput = get('custom-input');
      const customCardCopy = get('custom-card-copy');
      const errorMessage = get('error');
      const vaultCount = get('vault-count');
      const vaultProgress = get('vault-progress');
      const claimButton = get('claim');
      const claimLabel = get('claim-label');
      const claimPrice = get('claim-price');
      const delivery = get('delivery');
      const status = get('status');
      const audioSample = get('audio-sample');
      const audio = get('audio');
      const audioUi = get('audio-ui');
      const audioToggle = get('audio-toggle');
      const audioSeek = get('audio-seek');
      const audioCurrent = get('audio-current');
      const audioDuration = get('audio-duration');
      const audioStatus = get('audio-status');
      const audioWave = root.querySelector('[data-ac-audio-wave]');
      const audioName = 'audio sample';

      let selectedFormatKey = 'ebooks';
      let selectedChoice = 'indulgent';
      let selectedCents = config.formats.ebooks.tiers[1].priceCents;
      let customMode = false;
      let adding = false;

      function formatData() {
        return config.formats[selectedFormatKey];
      }

      function tierByKey(key) {
        return formatData().tiers.find((tier) => tier.key === key);
      }

      function earnedTier(amountCents) {
        return formatData().tiers
          .filter((tier) => tier.id && tier.available && amountCents >= tier.priceCents)
          .sort((a, b) => a.priceCents - b.priceCents)
          .pop() || null;
      }

      function configurationProblem() {
        if (config.currency !== 'USD') {
          return 'This first functional build checks out in USD. Please switch the store currency to USD.';
        }

        const missingTiers = formatData().tiers.some((tier) => !tier.id || !tier.available);
        if (missingTiers) {
          return 'This format is missing one or more matching, available price variants in the section settings.';
        }

        if (!config.adjustments.dollar.id || !config.adjustments.cent.id) {
          return 'Select the unlisted PWYW adjustment product in this section’s settings.';
        }

        if (!config.adjustments.dollar.available || !config.adjustments.cent.available) {
          return 'Both adjustment variants must be available for sale.';
        }

        if (config.adjustments.dollar.priceCents !== 100 || config.adjustments.cent.priceCents !== 1) {
          return 'The adjustment variants must be exactly $1.00 and $0.01 in USD.';
        }

        return '';
      }

      function customerValidation() {
        const minimum = formatData().tiers[0].priceCents;
        if (!Number.isInteger(selectedCents)) {
          return `Enter a price using no more than two decimal places.`;
        }
        if (selectedCents < minimum) {
          return `The minimum for this format is ${money(minimum, config.currency)}.`;
        }
        if (selectedCents > config.maximumCustomCents) {
          return `The maximum custom price is ${money(config.maximumCustomCents, config.currency)}.`;
        }
        return '';
      }

      function currentValidation() {
        const customerProblem = customerValidation();
        if (customerProblem) return customerProblem;
        if (!earnedTier(selectedCents)) {
          return 'The matching entitlement variant is unavailable.';
        }
        return configurationProblem();
      }

      function audioTime(seconds) {
        if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
        const wholeSeconds = Math.floor(seconds);
        const minutes = Math.floor(wholeSeconds / 60);
        const remainder = String(wholeSeconds % 60).padStart(2, '0');
        return `${minutes}:${remainder}`;
      }

      function updateAudioProgress() {
        if (!audio || !audioSeek || !audioCurrent || !audioDuration) return;
        const hasDuration = Number.isFinite(audio.duration) && audio.duration > 0;
        const percent = hasDuration ? Math.min(100, Math.max(0, (audio.currentTime / audio.duration) * 100)) : 0;

        audioSeek.value = String(percent);
        audioSeek.disabled = !hasDuration;
        audioSeek.setAttribute('aria-valuetext', `${audioTime(audio.currentTime)} of ${audioTime(audio.duration)}`);
        audioCurrent.textContent = audioTime(audio.currentTime);
        audioDuration.textContent = audioTime(audio.duration);
        if (audioWave) audioWave.style.setProperty('--ac-audio-progress', `${percent}%`);
      }

      function updateAudioButton() {
        if (!audio || !audioToggle) return;
        const isPlaying = !audio.paused && !audio.ended;
        audioToggle.classList.toggle('is-playing', isPlaying);
        audioToggle.setAttribute('aria-label', `${isPlaying ? 'Pause' : 'Play'} ${audioName}`);
      }

      function showAudioError(message) {
        if (!audioStatus) return;
        audioStatus.textContent = message;
        audioStatus.hidden = false;
      }

      function renderAudioVisibility() {
        if (!audioSample) return;
        const showOnEbooks = audioSample.dataset.acAudioOnEbooks === 'true';
        const shouldShow = selectedFormatKey !== 'ebooks' || showOnEbooks;
        audioSample.hidden = !shouldShow;

        if (!shouldShow && audio && !audio.paused) {
          audio.pause();
        }
      }

      function setupAudioPlayer() {
        if (!audio || !audioUi || !audioToggle || !audioSeek) return;

        audio.controls = false;
        audio.hidden = true;
        audioUi.hidden = false;
        audioSeek.disabled = true;

        audioToggle.addEventListener('click', async () => {
          if (audio.paused || audio.ended) {
            if (audioStatus) audioStatus.hidden = true;
            try {
              await audio.play();
            } catch (error) {
              showAudioError('The sample could not start. Please check your connection and try again.');
            }
          } else {
            audio.pause();
          }
        });

        audioSeek.addEventListener('input', () => {
          if (!Number.isFinite(audio.duration) || audio.duration <= 0) return;
          audio.currentTime = (Number(audioSeek.value) / 100) * audio.duration;
          updateAudioProgress();
        });

        audio.addEventListener('loadedmetadata', updateAudioProgress);
        audio.addEventListener('durationchange', updateAudioProgress);
        audio.addEventListener('timeupdate', updateAudioProgress);
        audio.addEventListener('play', updateAudioButton);
        audio.addEventListener('pause', updateAudioButton);
        audio.addEventListener('ended', () => {
          updateAudioButton();
          updateAudioProgress();
        });
        audio.addEventListener('error', () => {
          audioToggle.disabled = true;
          audioSeek.disabled = true;
          showAudioError('This sample is temporarily unavailable.');
        });

        updateAudioButton();
        updateAudioProgress();
      }

      function renderVault() {
        const tier = earnedTier(selectedCents);
        const unlocked = tier ? formatData().tiers.findIndex((item) => item.key === tier.key) + 1 : 0;
        vaultCount.textContent = `Clout level ${unlocked}/3`;
        vaultProgress.style.width = `${unlocked <= 1 ? 0 : ((unlocked - 1) / 2) * 100}%`;
        vaultNodes.forEach((node, index) => {
          node.classList.toggle('is-unlocked', index < unlocked);
        });
        vaultTicks.forEach((tick, index) => {
          tick.classList.toggle('is-unlocked', unlocked >= index + 2);
        });
        vaultItems.forEach((item, index) => {
          item.classList.toggle('is-unlocked', index < unlocked);
        });
      }

      function renderMobileOffer() {
        if (!mobilePrice || !mobileClaim) return;
        const minimum = formatData().tiers[0].priceCents;
        const labels = mobileCopy.claims;
        mobileRetail.textContent = money(formatData().tiers[2].priceCents, config.currency);
        formatSummary.textContent = mobileCopy.titles[selectedFormatKey];
        if (desktopStep) desktopStep.textContent = 'STEP 2 OF 2 · ' + ({ebooks: 'EBOOKS', audio: 'AUDIOBOOKS', complete: 'EBOOKS + AUDIOBOOKS'}[selectedFormatKey]) + ' SELECTED';
        if (desktopCopy) desktopCopy.textContent = ({ebooks: 'Five bestselling dark romance eBooks.', audio: 'Five bestselling dark romance audiobooks.', complete: 'Five bestselling dark romance stories to read and hear.'}[selectedFormatKey]) + ' Delivered instantly through BookFunnel.';
        if (desktopAudio) {
          desktopAudio.hidden = selectedFormatKey === 'ebooks';
          if (desktopAudio.hidden) desktopAudio.querySelector('audio')?.pause();
        }
        formatSummary.closest('.acpwyw2__format-summary').dataset.ac2SummaryFormat = selectedFormatKey;
        const tooLow = Number.isInteger(selectedCents) && selectedCents < minimum && Boolean(mobilePrice.value.trim());
        mobileMinimum.textContent = money(minimum, config.currency) + ' minimum — Support indie authors ♥';
        mobileMinimum.hidden = !tooLow;
        mobilePrice.closest('.acpwyw2__price-field').classList.toggle('is-below-minimum', tooLow);
        const bonusTier = tierByKey('indulgent');
        const eligible = bonusTier && Number.isInteger(selectedCents) && selectedCents >= bonusTier.priceCents && !customerValidation();
        if (!eligible) selectedGift = null;
        giftPanel.classList.toggle('is-unlocked', Boolean(eligible));
        giftPanel.querySelector('[data-ac2-gift-heading]').textContent = eligible ? mobileCopy.giftUnlocked : mobileCopy.giftLocked.replace('{amount}', bonusTier ? money(bonusTier.priceCents, config.currency) : '');
        giftPanel.querySelector('[data-ac2-gift-note]').textContent = eligible
          ? (selectedGift ? selectedGift.title + ' — ' : '') + mobileCopy.giftIncluded
          : '';
        giftPanel.querySelector('[data-ac2-gift-note]').hidden = !eligible;
        giftButtons.forEach((button) => {
          button.disabled = !eligible || adding || !button.dataset.ac2GiftId;
          const selected = Boolean(selectedGift && selectedGift.handle === button.dataset.ac2GiftOption);
          button.setAttribute('aria-pressed', String(selected));
          button.classList.toggle('is-selected', selected);
        });
        mobilePrice.setAttribute('aria-label', 'Your price in US dollars. Minimum ' + money(minimum, config.currency));
        const message = mobilePrice.value.trim() && !tooLow ? customerValidation() : '';
        mobileError.textContent = message;
        mobileError.hidden = !message;
        mobilePrice.setAttribute('aria-invalid', String(tooLow || Boolean(message)));
        mobileClaim.disabled = !mobilePrice.value.trim() || Boolean(currentValidation()) || adding;
        mobileClaim.textContent = adding ? 'Building your order…' : labels[selectedFormatKey];
        mobileStatus.textContent = status.textContent;
        mobileStatus.hidden = !status.textContent;
      }

      function render() {
        const product = formatData();
        const retail = product.tiers[2].priceCents;
        const validation = currentValidation();
        const customerMessage = customerValidation();
        const hasPrice = Number.isInteger(selectedCents);

        formatButtons.forEach((button) => {
          button.setAttribute('aria-selected', String(button.dataset.acFormat === selectedFormatKey));
        });
        renderAudioVisibility();

        priceButtons.forEach((button) => {
          const key = button.dataset.acPriceChoice;
          const isCustom = key === 'custom';
          const tier = isCustom ? null : tierByKey(key);
          const selected = isCustom ? customMode : !customMode && key === selectedChoice;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
          button.disabled = isCustom ? false : !tier || !tier.id || !tier.available;
          const value = button.querySelector(`[data-ac-price-value="${key}"]`);
          if (value && tier) value.textContent = money(tier.priceCents, config.currency);
        });
        customCard.classList.toggle('is-selected', customMode);

        title.textContent = product.title;
        eyebrow.textContent = product.eyebrow;
        description.textContent = product.description;
        retailPrice.textContent = money(retail, config.currency);
        const minimum = product.tiers[0].priceCents;
        const minimumAmount = (minimum / 100).toFixed(2);
        const minimumPrompt = `${minimumAmount} minimum`;
        customInput.placeholder = customMode
          ? minimumPrompt
          : '';
        customInput.setAttribute('aria-label', `Your custom price in US dollars. Minimum ${money(minimum, config.currency)}.`);
        claimLabel.textContent = customMode && !hasPrice ? config.labels.enterPrice : product.claim;
        claimPrice.textContent = hasPrice ? money(selectedCents, config.currency) : config.labels.yourPrice;
        delivery.textContent = product.delivery;
        customCardCopy.textContent = customMode ? 'Support indie authors ♥' : product.customCopy;

        if (product.image) {
          productImage.src = product.image;
          productImage.alt = product.title;
        } else {
          productImage.removeAttribute('src');
          productImage.alt = '';
        }

        const hasCustomText = customInput.value.trim() !== '';
        errorMessage.hidden = !customerMessage || (customMode && !hasCustomText);
        errorMessage.textContent = customerMessage;
        claimButton.disabled = Boolean(validation) || adding;
        renderVault();
        renderMobileOffer();
      }

      function chooseFormat(key) {
        selectedFormatKey = key;
        selectedChoice = 'indulgent';
        selectedCents = formatData().tiers[1].priceCents;
        customMode = false;
        customInput.value = '';
        status.textContent = '';
        render();
      }

      function scrollMobileOfferIntoView() {
        const header = mobileMenu && mobileMenu.closest('.section-header-mobile');
        root.style.setProperty('--ac2-header-height', (header ? header.getBoundingClientRect().height : 69) + 'px');
        root.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
      function openMobileOffer(key) {
        selectedGift = null;
        chooseFormat(key);
        customMode = true;
        selectedChoice = 'custom';
        selectedCents = null;
        customInput.value = '';
        mobilePrice.value = '';
        const labels = mobileCopy.titles;
        detailTitle.textContent = labels[key];
        root.classList.add('is-ac2-detail');
        render();
        scrollMobileOfferIntoView();
        (window.matchMedia('(min-width:750px)').matches ? detailTitle : formatSummary).focus({ preventScroll: true });
      }
      formatEntryButtons.forEach((button) => {
        button.addEventListener('click', () => openMobileOffer(button.dataset.ac2Format));
      });
      if (backButton && mobileMenu && window.matchMedia('(max-width:749px)').matches) mobileMenu.parentElement.appendChild(backButton);
      if (backButton) backButton.addEventListener('click', () => {
        root.classList.remove('is-ac2-detail');
        scrollMobileOfferIntoView();
        if (mobileMenu) mobileMenu.focus({ preventScroll: true });
      });
      if (changeFormatButton) changeFormatButton.addEventListener('click', () => {
        root.classList.remove('is-ac2-detail');
        scrollMobileOfferIntoView();
        const currentChoice = formatEntryButtons.find(button => button.dataset.ac2Format === selectedFormatKey);
        if (currentChoice) currentChoice.focus({ preventScroll: true });
      });
      giftButtons.forEach(button => button.addEventListener('click', () => {
        if (button.disabled) return;
        selectedGift = { handle: button.dataset.ac2GiftOption, id: Number(button.dataset.ac2GiftId), title: button.dataset.ac2GiftTitle };
        renderMobileOffer();
      }));
      if (mobilePrice) mobilePrice.addEventListener('input', () => {
        customMode = true;
        selectedChoice = 'custom';
        customInput.value = mobilePrice.value;
        selectedCents = parseMoneyToCents(mobilePrice.value);
        status.textContent = '';
        render();
      });
      if (mobileClaim) mobileClaim.addEventListener('click', () => {
        if (mobileClaim.disabled) return;
        claimButton.click();
        renderMobileOffer();
      });
      if (mobilePrice) mobilePrice.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && !event.isComposing) {
          event.preventDefault();
          mobileClaim.click();
        }
      });
      const mobileStatusObserver = new MutationObserver(renderMobileOffer);
      mobileStatusObserver.observe(status, { childList: true, subtree: true });
      mobileStatusObserver.observe(claimButton, { attributes: true, attributeFilter: ['disabled'] });
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(root)) return;
        mobileStatusObserver.disconnect();
        if (backButton) backButton.remove();
      });

      formatButtons.forEach((button) => {
        button.addEventListener('click', () => chooseFormat(button.dataset.acFormat));
      });

      function activateCustomPrice() {
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        customMode = true;
        status.textContent = '';
        render();
        window.requestAnimationFrame(() => customInput.focus());
      }

      priceButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const key = button.dataset.acPriceChoice;
          if (key === 'custom') {
            activateCustomPrice();
            return;
          }

          const tier = tierByKey(key);
          if (!tier || !tier.id || !tier.available) return;
          selectedChoice = tier.key;
          selectedCents = tier.priceCents;
          customMode = false;
          customInput.value = '';
          status.textContent = '';
          render();
        });
      });

      customCard.addEventListener('click', (event) => {
        if (event.target.closest('[data-ac-price-choice="custom"]')) return;
        activateCustomPrice();
      });

      customInput.addEventListener('focus', () => {
        if (customMode) return;
        customMode = true;
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        status.textContent = '';
        render();
      });

      customInput.addEventListener('input', () => {
        customMode = true;
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        status.textContent = '';
        render();
      });

      customInput.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.isComposing) return;
        event.preventDefault();
        claimButton.click();
      });

      claimButton.addEventListener('click', async () => {
        if (adding) return;
        const validation = currentValidation();
        if (validation) {
          render();
          return;
        }

        const product = formatData();
        const tier = earnedTier(selectedCents);
        const parentPriceCents = Number.isInteger(tier.basePriceCents) ? tier.basePriceCents : tier.priceCents;
        const differenceCents = selectedCents - parentPriceCents;
        const dollarQuantity = Math.floor(differenceCents / 100);
        const centQuantity = differenceCents % 100;
        const purchaseGroup = groupId();
        const chosenPrice = `${money(selectedCents, config.currency)} ${config.currency}`;
        const accessLabels = {
          minimum: 'Complete Collection',
          indulgent: 'Certified Enabler',
          retail: 'Full Bonus Vault'
        };
        const accessLabel = accessLabels[tier.key] || 'Complete Collection';
        const items = [
          {
            id: Number(tier.id),
            quantity: 1,
            properties: {
              'Your price': chosenPrice,
              'Access': accessLabel,
              '_pwyw': 'true',
              '_pwyw_group': purchaseGroup,
              '_pwyw_format': selectedFormatKey,
              '_pwyw_tier': tier.key,
              '_pwyw_total_cents': String(selectedCents)
            }
          }
        ];

        if (dollarQuantity > 0) {
          items.push({
            id: Number(config.adjustments.dollar.id),
            quantity: dollarQuantity,
            parent_id: Number(tier.id),
            properties: {
              '_pwyw_adjustment': 'dollar',
              '_pwyw_group': purchaseGroup,
              '_pwyw_parent_variant_id': String(tier.id)
            }
          });
        }

        if (centQuantity > 0) {
          items.push({
            id: Number(config.adjustments.cent.id),
            quantity: centQuantity,
            parent_id: Number(tier.id),
            properties: {
              '_pwyw_adjustment': 'cent',
              '_pwyw_group': purchaseGroup,
              '_pwyw_parent_variant_id': String(tier.id)
            }
          });
        }

        const qualifiesForGift = root.classList.contains('is-ac2-detail') && selectedCents >= tierByKey('indulgent').priceCents;
        let mobileGift = qualifiesForGift ? selectedGift : null;
        if (qualifiesForGift && !mobileGift) {
          const defaultGiftButton = giftButtons.find(button => button.dataset.ac2GiftOption === 'a-night-by-my-fire');
          if (!defaultGiftButton || !Number(defaultGiftButton.dataset.ac2GiftId)) {
            status.textContent = 'Please choose an available bonus novella before continuing.';
            render();
            return;
          }
          mobileGift = { handle: defaultGiftButton.dataset.ac2GiftOption, id: Number(defaultGiftButton.dataset.ac2GiftId), title: defaultGiftButton.dataset.ac2GiftTitle };
          selectedGift = mobileGift;
        }
        if (mobileGift) {
          items.push({ id: mobileGift.id, quantity: 1, parent_id: Number(tier.id), properties: {
            '_pwyw_bonus': 'true', '_pwyw_group': purchaseGroup, '_pwyw_parent_variant_id': String(tier.id)
          }});
        }
        adding = true;
        claimButton.disabled = true;
        claimLabel.textContent = 'Building your order…';
        status.textContent = '';

        const storeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

        try {
          if (mobileGift) {
            const priorResponse = await fetch(storeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
            if (!priorResponse.ok) throw new Error('Could not verify your cart. Please try again.');
            const priorCart = await priorResponse.json();
            if (priorCart.items.some(item => item.properties && item.properties._pwyw_bonus === 'true')) {
              throw new Error('Your cart already has a bonus novella. Only one bonus is included per order. Please review your cart before adding another.');
            }
          }
          const response = await fetch(`${storeRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          });
          const payload = await response.json();

          if (!response.ok) {
            throw new Error(payload.description || payload.message || 'Shopify could not add this offer to the cart.');
          }

          if (mobileGift) {
            const verifiedResponse = await fetch(storeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
            if (!verifiedResponse.ok) throw new Error('Please review your cart to confirm the bonus is free before checking out.');
            const verifiedCart = await verifiedResponse.json();
            const addedGift = verifiedCart.items.find(item => item.properties && item.properties._pwyw_group === purchaseGroup && item.properties._pwyw_bonus === 'true');
            if (!addedGift || addedGift.final_line_price !== 0) {
              const updates = {};
              verifiedCart.items.filter(item => item.properties && item.properties._pwyw_group === purchaseGroup).forEach(item => { updates[item.key] = 0; });
              const rollback = await fetch(storeRoot + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
              if (!rollback.ok) throw new Error('Please review your cart before checkout: the bonus discount could not be confirmed.');
              throw new Error('The bonus discount could not be applied, possibly because of another discount in your cart. This offer was not added.');
            }
          }
          status.textContent = 'Offer added. Opening secure checkout…';
          const destination = config.destination === 'cart' ? 'cart' : 'checkout';
          window.location.assign(`${storeRoot}${destination}`);
        } catch (error) {
          adding = false;
          status.textContent = error && error.message
            ? error.message
            : 'Something interrupted the cart. Please try once more.';
          render();
        }
      });

      setupAudioPlayer();
      render();
    }

    function initializeAll(scope) {
      const container = scope || document;
      if (container.matches && container.matches(SELECTOR)) initialize(container);
      container.querySelectorAll(SELECTOR).forEach(initialize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac-pwyw-offer-2-cherry-blossom"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-ac-pwyw2]';

    function money(cents, currency) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(cents / 100);
    }

    function parseMoneyToCents(rawValue) {
      const cleaned = String(rawValue || '').trim().replace(/[$\s]/g, '').replace(',', '.');
      if (!/^\d+(?:\.\d{0,2})?$/.test(cleaned)) return null;
      const parts = cleaned.split('.');
      const whole = Number(parts[0]);
      const fraction = Number((parts[1] || '').padEnd(2, '0'));
      if (!Number.isSafeInteger(whole) || whole < 0) return null;
      return (whole * 100) + fraction;
    }

    function groupId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return `pwyw-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }

    function initialize(root) {
      if (!root || root.dataset.acPwyw2Ready === 'true') return;

      const configNode = root.querySelector('[data-ac-pwyw2-config]');
      if (!configNode) return;

      let config;
      try {
        config = JSON.parse(configNode.textContent);
      } catch (error) {
        const visibleStatus = root.querySelector('[data-ac-role="status"]');
        if (visibleStatus) {
          visibleStatus.textContent = 'The offer configuration could not load. Please contact the store owner.';
        }
        root.querySelectorAll('button').forEach((button) => {
          button.disabled = true;
        });
        console.error('AC PWYW configuration error:', error);
        return;
      }
      root.dataset.acPwyw2Ready = 'true';

      const get = (role) => root.querySelector(`[data-ac-role="${role}"]`);
      const formatButtons = Array.from(root.querySelectorAll('[data-ac-format]'));
      const formatEntryButtons = Array.from(root.querySelectorAll('[data-ac2-format]'));
      const detailTitle = root.querySelector('[data-ac2-detail-title]');
      const backButton = root.querySelector('[data-ac2-back]');
      const mobilePrice = root.querySelector('[data-ac2-price]');
      const mobileMinimum = root.querySelector('[data-ac2-minimum]');
      const changeFormatButton = root.querySelector('[data-ac2-change-format]');
      const formatSummary = root.querySelector('[data-ac2-format-name]');
      const giftPanel = root.querySelector('[data-ac2-gift]');
      const giftButtons = Array.from(root.querySelectorAll('[data-ac2-gift-option]'));
      let selectedGift = null;
      const mobileRetail = root.querySelector('[data-ac2-retail]');
      const mobileError = root.querySelector('[data-ac2-error]');
      const mobileClaim = root.querySelector('[data-ac2-claim]');
      const mobileStatus = root.querySelector('[data-ac2-status]');
      const mobileMenu = document.querySelector('.item__mobile--hamburger > .mobileMenu-toggle');
      const mobileCopy = JSON.parse(root.querySelector('[data-ac2-copy]').textContent);

      const priceButtons = Array.from(root.querySelectorAll('[data-ac-price-choice]'));
      const vaultItems = Array.from(root.querySelectorAll('[data-ac-vault-item]'));
      const vaultNodes = Array.from(root.querySelectorAll('[data-ac-vault-node]'));
      const vaultTicks = Array.from(root.querySelectorAll('[data-ac-vault-tick]'));
      const title = get('title');
      const eyebrow = get('eyebrow');
      const description = get('description');
      const productImage = get('product-image');
      const retailPrice = get('retail-price');
      const customCard = root.querySelector('[data-ac-custom-card]');
      const customInput = get('custom-input');
      const customCardCopy = get('custom-card-copy');
      const errorMessage = get('error');
      const vaultCount = get('vault-count');
      const vaultProgress = get('vault-progress');
      const claimButton = get('claim');
      const claimLabel = get('claim-label');
      const claimPrice = get('claim-price');
      const delivery = get('delivery');
      const status = get('status');
      const audioSample = get('audio-sample');
      const audio = get('audio');
      const audioUi = get('audio-ui');
      const audioToggle = get('audio-toggle');
      const audioSeek = get('audio-seek');
      const audioCurrent = get('audio-current');
      const audioDuration = get('audio-duration');
      const audioStatus = get('audio-status');
      const audioWave = root.querySelector('[data-ac-audio-wave]');
      const audioName = 'audio sample';

      let selectedFormatKey = 'ebooks';
      let selectedChoice = 'indulgent';
      let selectedCents = config.formats.ebooks.tiers[1].priceCents;
      let customMode = false;
      let adding = false;

      function formatData() {
        return config.formats[selectedFormatKey];
      }

      function tierByKey(key) {
        return formatData().tiers.find((tier) => tier.key === key);
      }

      function earnedTier(amountCents) {
        return formatData().tiers
          .filter((tier) => tier.id && tier.available && amountCents >= tier.priceCents)
          .sort((a, b) => a.priceCents - b.priceCents)
          .pop() || null;
      }

      function configurationProblem() {
        if (config.currency !== 'USD') {
          return 'This first functional build checks out in USD. Please switch the store currency to USD.';
        }

        const missingTiers = formatData().tiers.some((tier) => !tier.id || !tier.available);
        if (missingTiers) {
          return 'This format is missing one or more matching, available price variants in the section settings.';
        }

        if (!config.adjustments.dollar.id || !config.adjustments.cent.id) {
          return 'Select the unlisted PWYW adjustment product in this section’s settings.';
        }

        if (!config.adjustments.dollar.available || !config.adjustments.cent.available) {
          return 'Both adjustment variants must be available for sale.';
        }

        if (config.adjustments.dollar.priceCents !== 100 || config.adjustments.cent.priceCents !== 1) {
          return 'The adjustment variants must be exactly $1.00 and $0.01 in USD.';
        }

        return '';
      }

      function customerValidation() {
        const minimum = formatData().tiers[0].priceCents;
        if (!Number.isInteger(selectedCents)) {
          return `Enter a price using no more than two decimal places.`;
        }
        if (selectedCents < minimum) {
          return `The minimum for this format is ${money(minimum, config.currency)}.`;
        }
        if (selectedCents > config.maximumCustomCents) {
          return `The maximum custom price is ${money(config.maximumCustomCents, config.currency)}.`;
        }
        return '';
      }

      function currentValidation() {
        const customerProblem = customerValidation();
        if (customerProblem) return customerProblem;
        if (!earnedTier(selectedCents)) {
          return 'The matching entitlement variant is unavailable.';
        }
        return configurationProblem();
      }

      function audioTime(seconds) {
        if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
        const wholeSeconds = Math.floor(seconds);
        const minutes = Math.floor(wholeSeconds / 60);
        const remainder = String(wholeSeconds % 60).padStart(2, '0');
        return `${minutes}:${remainder}`;
      }

      function updateAudioProgress() {
        if (!audio || !audioSeek || !audioCurrent || !audioDuration) return;
        const hasDuration = Number.isFinite(audio.duration) && audio.duration > 0;
        const percent = hasDuration ? Math.min(100, Math.max(0, (audio.currentTime / audio.duration) * 100)) : 0;

        audioSeek.value = String(percent);
        audioSeek.disabled = !hasDuration;
        audioSeek.setAttribute('aria-valuetext', `${audioTime(audio.currentTime)} of ${audioTime(audio.duration)}`);
        audioCurrent.textContent = audioTime(audio.currentTime);
        audioDuration.textContent = audioTime(audio.duration);
        if (audioWave) audioWave.style.setProperty('--ac-audio-progress', `${percent}%`);
      }

      function updateAudioButton() {
        if (!audio || !audioToggle) return;
        const isPlaying = !audio.paused && !audio.ended;
        audioToggle.classList.toggle('is-playing', isPlaying);
        audioToggle.setAttribute('aria-label', `${isPlaying ? 'Pause' : 'Play'} ${audioName}`);
      }

      function showAudioError(message) {
        if (!audioStatus) return;
        audioStatus.textContent = message;
        audioStatus.hidden = false;
      }

      function renderAudioVisibility() {
        if (!audioSample) return;
        const showOnEbooks = audioSample.dataset.acAudioOnEbooks === 'true';
        const shouldShow = selectedFormatKey !== 'ebooks' || showOnEbooks;
        audioSample.hidden = !shouldShow;

        if (!shouldShow && audio && !audio.paused) {
          audio.pause();
        }
      }

      function setupAudioPlayer() {
        if (!audio || !audioUi || !audioToggle || !audioSeek) return;

        audio.controls = false;
        audio.hidden = true;
        audioUi.hidden = false;
        audioSeek.disabled = true;

        audioToggle.addEventListener('click', async () => {
          if (audio.paused || audio.ended) {
            if (audioStatus) audioStatus.hidden = true;
            try {
              await audio.play();
            } catch (error) {
              showAudioError('The sample could not start. Please check your connection and try again.');
            }
          } else {
            audio.pause();
          }
        });

        audioSeek.addEventListener('input', () => {
          if (!Number.isFinite(audio.duration) || audio.duration <= 0) return;
          audio.currentTime = (Number(audioSeek.value) / 100) * audio.duration;
          updateAudioProgress();
        });

        audio.addEventListener('loadedmetadata', updateAudioProgress);
        audio.addEventListener('durationchange', updateAudioProgress);
        audio.addEventListener('timeupdate', updateAudioProgress);
        audio.addEventListener('play', updateAudioButton);
        audio.addEventListener('pause', updateAudioButton);
        audio.addEventListener('ended', () => {
          updateAudioButton();
          updateAudioProgress();
        });
        audio.addEventListener('error', () => {
          audioToggle.disabled = true;
          audioSeek.disabled = true;
          showAudioError('This sample is temporarily unavailable.');
        });

        updateAudioButton();
        updateAudioProgress();
      }

      function renderVault() {
        const tier = earnedTier(selectedCents);
        const unlocked = tier ? formatData().tiers.findIndex((item) => item.key === tier.key) + 1 : 0;
        vaultCount.textContent = `Clout level ${unlocked}/3`;
        vaultProgress.style.width = `${unlocked <= 1 ? 0 : ((unlocked - 1) / 2) * 100}%`;
        vaultNodes.forEach((node, index) => {
          node.classList.toggle('is-unlocked', index < unlocked);
        });
        vaultTicks.forEach((tick, index) => {
          tick.classList.toggle('is-unlocked', unlocked >= index + 2);
        });
        vaultItems.forEach((item, index) => {
          item.classList.toggle('is-unlocked', index < unlocked);
        });
      }

      function renderMobileOffer() {
        if (!mobilePrice || !mobileClaim) return;
        const minimum = formatData().tiers[0].priceCents;
        const labels = mobileCopy.claims;
        mobileRetail.textContent = money(formatData().tiers[2].priceCents, config.currency);
        formatSummary.textContent = mobileCopy.titles[selectedFormatKey];
        formatSummary.closest('.acpwyw2__format-summary').dataset.ac2SummaryFormat = selectedFormatKey;
        const tooLow = Number.isInteger(selectedCents) && selectedCents < minimum && Boolean(mobilePrice.value.trim());
        mobileMinimum.textContent = money(minimum, config.currency) + ' minimum — Support indie authors ♥';
        mobileMinimum.hidden = !tooLow;
        mobilePrice.closest('.acpwyw2__price-field').classList.toggle('is-below-minimum', tooLow);
        const bonusTier = tierByKey('indulgent');
        const eligible = bonusTier && Number.isInteger(selectedCents) && selectedCents >= bonusTier.priceCents && !customerValidation();
        if (!eligible) selectedGift = null;
        giftPanel.classList.toggle('is-unlocked', Boolean(eligible));
        giftPanel.querySelector('[data-ac2-gift-heading]').textContent = eligible ? mobileCopy.giftUnlocked : mobileCopy.giftLocked.replace('{amount}', bonusTier ? money(bonusTier.priceCents, config.currency) : '');
        giftPanel.querySelector('[data-ac2-gift-note]').textContent = eligible
          ? (selectedGift ? selectedGift.title + ' — ' : '') + mobileCopy.giftIncluded
          : '';
        giftPanel.querySelector('[data-ac2-gift-note]').hidden = !eligible;
        giftButtons.forEach((button) => {
          button.disabled = !eligible || adding || !button.dataset.ac2GiftId;
          const selected = Boolean(selectedGift && selectedGift.handle === button.dataset.ac2GiftOption);
          button.setAttribute('aria-pressed', String(selected));
          button.classList.toggle('is-selected', selected);
        });
        mobilePrice.setAttribute('aria-label', 'Your price in US dollars. Minimum ' + money(minimum, config.currency));
        const message = mobilePrice.value.trim() && !tooLow ? customerValidation() : '';
        mobileError.textContent = message;
        mobileError.hidden = !message;
        mobilePrice.setAttribute('aria-invalid', String(tooLow || Boolean(message)));
        mobileClaim.disabled = !mobilePrice.value.trim() || Boolean(currentValidation()) || adding;
        mobileClaim.textContent = adding ? 'Building your order…' : labels[selectedFormatKey];
        mobileStatus.textContent = status.textContent;
        mobileStatus.hidden = !status.textContent;
      }

      function render() {
        const product = formatData();
        const retail = product.tiers[2].priceCents;
        const validation = currentValidation();
        const customerMessage = customerValidation();
        const hasPrice = Number.isInteger(selectedCents);

        formatButtons.forEach((button) => {
          button.setAttribute('aria-selected', String(button.dataset.acFormat === selectedFormatKey));
        });
        renderAudioVisibility();

        priceButtons.forEach((button) => {
          const key = button.dataset.acPriceChoice;
          const isCustom = key === 'custom';
          const tier = isCustom ? null : tierByKey(key);
          const selected = isCustom ? customMode : !customMode && key === selectedChoice;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
          button.disabled = isCustom ? false : !tier || !tier.id || !tier.available;
          const value = button.querySelector(`[data-ac-price-value="${key}"]`);
          if (value && tier) value.textContent = money(tier.priceCents, config.currency);
        });
        customCard.classList.toggle('is-selected', customMode);

        title.textContent = product.title;
        eyebrow.textContent = product.eyebrow;
        description.textContent = product.description;
        retailPrice.textContent = money(retail, config.currency);
        const minimum = product.tiers[0].priceCents;
        const minimumAmount = (minimum / 100).toFixed(2);
        const minimumPrompt = `${minimumAmount} minimum`;
        customInput.placeholder = customMode
          ? minimumPrompt
          : '';
        customInput.setAttribute('aria-label', `Your custom price in US dollars. Minimum ${money(minimum, config.currency)}.`);
        claimLabel.textContent = customMode && !hasPrice ? config.labels.enterPrice : product.claim;
        claimPrice.textContent = hasPrice ? money(selectedCents, config.currency) : config.labels.yourPrice;
        delivery.textContent = product.delivery;
        customCardCopy.textContent = customMode ? 'Support indie authors ♥' : product.customCopy;

        if (product.image) {
          productImage.src = product.image;
          productImage.alt = product.title;
        } else {
          productImage.removeAttribute('src');
          productImage.alt = '';
        }

        const hasCustomText = customInput.value.trim() !== '';
        errorMessage.hidden = !customerMessage || (customMode && !hasCustomText);
        errorMessage.textContent = customerMessage;
        claimButton.disabled = Boolean(validation) || adding;
        renderVault();
        renderMobileOffer();
      }

      function chooseFormat(key) {
        selectedFormatKey = key;
        selectedChoice = 'indulgent';
        selectedCents = formatData().tiers[1].priceCents;
        customMode = false;
        customInput.value = '';
        status.textContent = '';
        render();
      }

      function scrollMobileOfferIntoView() {
        const header = mobileMenu && mobileMenu.closest('.section-header-mobile');
        root.style.setProperty('--ac2-header-height', (header ? header.getBoundingClientRect().height : 69) + 'px');
        root.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
      function mobileHistoryEntry() {
        const entry = window.history.state && window.history.state.acPwywMobile;
        return entry && entry.rootId === root.id ? entry : null;
      }
      function showMobileFormats() {
        root.classList.remove('is-ac2-detail');
        scrollMobileOfferIntoView();
        const currentChoice = formatEntryButtons.find(button => button.dataset.ac2Format === selectedFormatKey);
        if (currentChoice) currentChoice.focus({ preventScroll: true });
        else if (mobileMenu) mobileMenu.focus({ preventScroll: true });
      }
      function openMobileOffer(key, updateHistory = true) {
        selectedGift = null;
        chooseFormat(key);
        customMode = true;
        selectedChoice = 'custom';
        selectedCents = null;
        customInput.value = '';
        mobilePrice.value = '';
        const labels = mobileCopy.titles;
        detailTitle.textContent = labels[key];
        const detailAlreadyOpen = root.classList.contains('is-ac2-detail');
        root.classList.add('is-ac2-detail');
        if (updateHistory) {
          const method = detailAlreadyOpen && mobileHistoryEntry() ? 'replaceState' : 'pushState';
          window.history[method]({
            ...window.history.state,
            acPwywMobile: { rootId: root.id, format: key }
          }, '');
        }
        render();
        scrollMobileOfferIntoView();
        formatSummary.focus({ preventScroll: true });
      }
      function returnToMobileFormats() {
        const entry = mobileHistoryEntry();
        if (entry && entry.format && root.classList.contains('is-ac2-detail')) {
          showMobileFormats();
          window.history.back();
        } else {
          showMobileFormats();
        }
      }
      function handleMobilePopState(event) {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        const entry = event.state && event.state.acPwywMobile;
        if (entry && entry.rootId === root.id && config.formats[entry.format]) {
          openMobileOffer(entry.format, false);
        } else {
          showMobileFormats();
        }
      }
      window.addEventListener('popstate', handleMobilePopState);
      formatEntryButtons.forEach((button) => {
        button.addEventListener('click', () => openMobileOffer(button.dataset.ac2Format));
      });
      if (backButton && mobileMenu) mobileMenu.parentElement.appendChild(backButton);
      if (backButton) backButton.addEventListener('click', returnToMobileFormats);
      if (changeFormatButton) changeFormatButton.addEventListener('click', returnToMobileFormats);
      giftButtons.forEach(button => button.addEventListener('click', () => {
        if (button.disabled) return;
        selectedGift = { handle: button.dataset.ac2GiftOption, id: Number(button.dataset.ac2GiftId), title: button.dataset.ac2GiftTitle };
        renderMobileOffer();
      }));
      if (mobilePrice) mobilePrice.addEventListener('input', () => {
        customMode = true;
        selectedChoice = 'custom';
        customInput.value = mobilePrice.value;
        selectedCents = parseMoneyToCents(mobilePrice.value);
        status.textContent = '';
        render();
      });
      if (mobileClaim) mobileClaim.addEventListener('click', () => {
        if (mobileClaim.disabled) return;
        claimButton.click();
        renderMobileOffer();
      });
      if (mobilePrice) mobilePrice.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && !event.isComposing) {
          event.preventDefault();
          mobileClaim.click();
        }
      });
      const mobileStatusObserver = new MutationObserver(renderMobileOffer);
      mobileStatusObserver.observe(status, { childList: true, subtree: true });
      mobileStatusObserver.observe(claimButton, { attributes: true, attributeFilter: ['disabled'] });
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(root)) return;
        mobileStatusObserver.disconnect();
        window.removeEventListener('popstate', handleMobilePopState);
        if (backButton) backButton.remove();
      });

      formatButtons.forEach((button) => {
        button.addEventListener('click', () => chooseFormat(button.dataset.acFormat));
      });

      function activateCustomPrice() {
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        customMode = true;
        status.textContent = '';
        render();
        window.requestAnimationFrame(() => customInput.focus());
      }

      priceButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const key = button.dataset.acPriceChoice;
          if (key === 'custom') {
            activateCustomPrice();
            return;
          }

          const tier = tierByKey(key);
          if (!tier || !tier.id || !tier.available) return;
          selectedChoice = tier.key;
          selectedCents = tier.priceCents;
          customMode = false;
          customInput.value = '';
          status.textContent = '';
          render();
        });
      });

      customCard.addEventListener('click', (event) => {
        if (event.target.closest('[data-ac-price-choice="custom"]')) return;
        activateCustomPrice();
      });

      customInput.addEventListener('focus', () => {
        if (customMode) return;
        customMode = true;
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        status.textContent = '';
        render();
      });

      customInput.addEventListener('input', () => {
        customMode = true;
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        status.textContent = '';
        render();
      });

      customInput.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.isComposing) return;
        event.preventDefault();
        claimButton.click();
      });

      claimButton.addEventListener('click', async () => {
        if (adding) return;
        const validation = currentValidation();
        if (validation) {
          render();
          return;
        }

        const product = formatData();
        const tier = earnedTier(selectedCents);
        const parentPriceCents = Number.isInteger(tier.basePriceCents) ? tier.basePriceCents : tier.priceCents;
        const differenceCents = selectedCents - parentPriceCents;
        const dollarQuantity = Math.floor(differenceCents / 100);
        const centQuantity = differenceCents % 100;
        const purchaseGroup = groupId();
        const chosenPrice = `${money(selectedCents, config.currency)} ${config.currency}`;
        const accessLabels = {
          minimum: 'Complete Collection',
          indulgent: 'Certified Enabler',
          retail: 'Full Bonus Vault'
        };
        const accessLabel = accessLabels[tier.key] || 'Complete Collection';
        const items = [
          {
            id: Number(tier.id),
            quantity: 1,
            properties: {
              'Your price': chosenPrice,
              'Access': accessLabel,
              '_pwyw': 'true',
              '_pwyw_group': purchaseGroup,
              '_pwyw_format': selectedFormatKey,
              '_pwyw_tier': tier.key,
              '_pwyw_total_cents': String(selectedCents)
            }
          }
        ];

        if (dollarQuantity > 0) {
          items.push({
            id: Number(config.adjustments.dollar.id),
            quantity: dollarQuantity,
            parent_id: Number(tier.id),
            properties: {
              '_pwyw_adjustment': 'dollar',
              '_pwyw_group': purchaseGroup,
              '_pwyw_parent_variant_id': String(tier.id)
            }
          });
        }

        if (centQuantity > 0) {
          items.push({
            id: Number(config.adjustments.cent.id),
            quantity: centQuantity,
            parent_id: Number(tier.id),
            properties: {
              '_pwyw_adjustment': 'cent',
              '_pwyw_group': purchaseGroup,
              '_pwyw_parent_variant_id': String(tier.id)
            }
          });
        }

        const qualifiesForMobileGift = window.matchMedia('(max-width: 749px)').matches && root.classList.contains('is-ac2-detail') && selectedCents >= tierByKey('indulgent').priceCents;
        let mobileGift = qualifiesForMobileGift ? selectedGift : null;
        if (qualifiesForMobileGift && !mobileGift) {
          const defaultGiftButton = giftButtons.find(button => button.dataset.ac2GiftOption === 'a-night-by-my-fire');
          if (!defaultGiftButton || !Number(defaultGiftButton.dataset.ac2GiftId)) {
            status.textContent = 'Please choose an available bonus novella before continuing.';
            render();
            return;
          }
          mobileGift = { handle: defaultGiftButton.dataset.ac2GiftOption, id: Number(defaultGiftButton.dataset.ac2GiftId), title: defaultGiftButton.dataset.ac2GiftTitle };
          selectedGift = mobileGift;
        }
        if (mobileGift) {
          items.push({ id: mobileGift.id, quantity: 1, parent_id: Number(tier.id), properties: {
            '_pwyw_bonus': 'true', '_pwyw_group': purchaseGroup, '_pwyw_parent_variant_id': String(tier.id)
          }});
        }
        adding = true;
        claimButton.disabled = true;
        claimLabel.textContent = 'Building your order…';
        status.textContent = '';

        const storeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

        try {
          if (mobileGift) {
            const priorResponse = await fetch(storeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
            if (!priorResponse.ok) throw new Error('Could not verify your cart. Please try again.');
            const priorCart = await priorResponse.json();
            if (priorCart.items.some(item => item.properties && item.properties._pwyw_bonus === 'true')) {
              throw new Error('Your cart already has a bonus novella. Only one bonus is included per order. Please review your cart before adding another.');
            }
          }
          const response = await fetch(`${storeRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          });
          const payload = await response.json();

          if (!response.ok) {
            throw new Error(payload.description || payload.message || 'Shopify could not add this offer to the cart.');
          }

          if (mobileGift) {
            const verifiedResponse = await fetch(storeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
            if (!verifiedResponse.ok) throw new Error('Please review your cart to confirm the bonus is free before checking out.');
            const verifiedCart = await verifiedResponse.json();
            const addedGift = verifiedCart.items.find(item => item.properties && item.properties._pwyw_group === purchaseGroup && item.properties._pwyw_bonus === 'true');
            if (!addedGift || addedGift.final_line_price !== 0) {
              const updates = {};
              verifiedCart.items.filter(item => item.properties && item.properties._pwyw_group === purchaseGroup).forEach(item => { updates[item.key] = 0; });
              const rollback = await fetch(storeRoot + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
              if (!rollback.ok) throw new Error('Please review your cart before checkout: the bonus discount could not be confirmed.');
              throw new Error('The bonus discount could not be applied, possibly because of another discount in your cart. This offer was not added.');
            }
          }
          status.textContent = 'Offer added. Opening secure checkout…';
          const destination = config.destination === 'cart' ? 'cart' : 'checkout';
          window.location.assign(`${storeRoot}${destination}`);
        } catch (error) {
          adding = false;
          status.textContent = error && error.message
            ? error.message
            : 'Something interrupted the cart. Please try once more.';
          render();
        }
      });

      setupAudioPlayer();
      render();
      const restoredMobileEntry = mobileHistoryEntry();
      if (window.matchMedia('(max-width: 749px)').matches && restoredMobileEntry && config.formats[restoredMobileEntry.format]) {
        openMobileOffer(restoredMobileEntry.format, false);
      }
    }

    function initializeAll(scope) {
      const container = scope || document;
      if (container.matches && container.matches(SELECTOR)) initialize(container);
      container.querySelectorAll(SELECTOR).forEach(initialize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac-pwyw-offer-2-gothic"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-ac-pwyw2]';

    function money(cents, currency) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(cents / 100);
    }

    function parseMoneyToCents(rawValue) {
      const cleaned = String(rawValue || '').trim().replace(/[$\s]/g, '').replace(',', '.');
      if (!/^\d+(?:\.\d{0,2})?$/.test(cleaned)) return null;
      const parts = cleaned.split('.');
      const whole = Number(parts[0]);
      const fraction = Number((parts[1] || '').padEnd(2, '0'));
      if (!Number.isSafeInteger(whole) || whole < 0) return null;
      return (whole * 100) + fraction;
    }

    function groupId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return `pwyw-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }

    function initialize(root) {
      if (!root || root.dataset.acPwyw2Ready === 'true') return;

      const configNode = root.querySelector('[data-ac-pwyw2-config]');
      if (!configNode) return;

      let config;
      try {
        config = JSON.parse(configNode.textContent);
      } catch (error) {
        const visibleStatus = root.querySelector('[data-ac-role="status"]');
        if (visibleStatus) {
          visibleStatus.textContent = 'The offer configuration could not load. Please contact the store owner.';
        }
        root.querySelectorAll('button').forEach((button) => {
          button.disabled = true;
        });
        console.error('AC PWYW configuration error:', error);
        return;
      }
      root.dataset.acPwyw2Ready = 'true';

      const get = (role) => root.querySelector(`[data-ac-role="${role}"]`);
      const formatButtons = Array.from(root.querySelectorAll('[data-ac-format]'));
      const formatEntryButtons = Array.from(root.querySelectorAll('[data-ac2-format]'));
      const detailTitle = root.querySelector('[data-ac2-detail-title]');
      const backButton = root.querySelector('[data-ac2-back]');
      const mobilePrice = root.querySelector('[data-ac2-price]');
      const mobileMinimum = root.querySelector('[data-ac2-minimum]');
      const changeFormatButton = root.querySelector('[data-ac2-change-format]');
      const formatSummary = root.querySelector('[data-ac2-format-name]');
      const giftPanel = root.querySelector('[data-ac2-gift]');
      const giftButtons = Array.from(root.querySelectorAll('[data-ac2-gift-option]'));
      let selectedGift = null;
      const mobileRetail = root.querySelector('[data-ac2-retail]');
      const mobileError = root.querySelector('[data-ac2-error]');
      const mobileClaim = root.querySelector('[data-ac2-claim]');
      const mobileStatus = root.querySelector('[data-ac2-status]');
      const mobileMenu = document.querySelector('.item__mobile--hamburger > .mobileMenu-toggle');
      const mobileCopy = JSON.parse(root.querySelector('[data-ac2-copy]').textContent);

      const priceButtons = Array.from(root.querySelectorAll('[data-ac-price-choice]'));
      const vaultItems = Array.from(root.querySelectorAll('[data-ac-vault-item]'));
      const vaultNodes = Array.from(root.querySelectorAll('[data-ac-vault-node]'));
      const vaultTicks = Array.from(root.querySelectorAll('[data-ac-vault-tick]'));
      const title = get('title');
      const eyebrow = get('eyebrow');
      const description = get('description');
      const productImage = get('product-image');
      const retailPrice = get('retail-price');
      const customCard = root.querySelector('[data-ac-custom-card]');
      const customInput = get('custom-input');
      const customCardCopy = get('custom-card-copy');
      const errorMessage = get('error');
      const vaultCount = get('vault-count');
      const vaultProgress = get('vault-progress');
      const claimButton = get('claim');
      const claimLabel = get('claim-label');
      const claimPrice = get('claim-price');
      const delivery = get('delivery');
      const status = get('status');
      const audioSample = get('audio-sample');
      const audio = get('audio');
      const audioUi = get('audio-ui');
      const audioToggle = get('audio-toggle');
      const audioSeek = get('audio-seek');
      const audioCurrent = get('audio-current');
      const audioDuration = get('audio-duration');
      const audioStatus = get('audio-status');
      const audioWave = root.querySelector('[data-ac-audio-wave]');
      const audioName = 'audio sample';

      let selectedFormatKey = 'ebooks';
      let selectedChoice = 'indulgent';
      let selectedCents = config.formats.ebooks.tiers[1].priceCents;
      let customMode = false;
      let adding = false;

      function formatData() {
        return config.formats[selectedFormatKey];
      }

      function tierByKey(key) {
        return formatData().tiers.find((tier) => tier.key === key);
      }

      function earnedTier(amountCents) {
        return formatData().tiers
          .filter((tier) => tier.id && tier.available && amountCents >= tier.priceCents)
          .sort((a, b) => a.priceCents - b.priceCents)
          .pop() || null;
      }

      function configurationProblem() {
        if (config.currency !== 'USD') {
          return 'This first functional build checks out in USD. Please switch the store currency to USD.';
        }

        const missingTiers = formatData().tiers.some((tier) => !tier.id || !tier.available);
        if (missingTiers) {
          return 'This format is missing one or more matching, available price variants in the section settings.';
        }

        if (!config.adjustments.dollar.id || !config.adjustments.cent.id) {
          return 'Select the unlisted PWYW adjustment product in this section’s settings.';
        }

        if (!config.adjustments.dollar.available || !config.adjustments.cent.available) {
          return 'Both adjustment variants must be available for sale.';
        }

        if (config.adjustments.dollar.priceCents !== 100 || config.adjustments.cent.priceCents !== 1) {
          return 'The adjustment variants must be exactly $1.00 and $0.01 in USD.';
        }

        return '';
      }

      function customerValidation() {
        const minimum = formatData().tiers[0].priceCents;
        if (!Number.isInteger(selectedCents)) {
          return `Enter a price using no more than two decimal places.`;
        }
        if (selectedCents < minimum) {
          return `The minimum for this format is ${money(minimum, config.currency)}.`;
        }
        if (selectedCents > config.maximumCustomCents) {
          return `The maximum custom price is ${money(config.maximumCustomCents, config.currency)}.`;
        }
        return '';
      }

      function currentValidation() {
        const customerProblem = customerValidation();
        if (customerProblem) return customerProblem;
        if (!earnedTier(selectedCents)) {
          return 'The matching entitlement variant is unavailable.';
        }
        return configurationProblem();
      }

      function audioTime(seconds) {
        if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
        const wholeSeconds = Math.floor(seconds);
        const minutes = Math.floor(wholeSeconds / 60);
        const remainder = String(wholeSeconds % 60).padStart(2, '0');
        return `${minutes}:${remainder}`;
      }

      function updateAudioProgress() {
        if (!audio || !audioSeek || !audioCurrent || !audioDuration) return;
        const hasDuration = Number.isFinite(audio.duration) && audio.duration > 0;
        const percent = hasDuration ? Math.min(100, Math.max(0, (audio.currentTime / audio.duration) * 100)) : 0;

        audioSeek.value = String(percent);
        audioSeek.disabled = !hasDuration;
        audioSeek.setAttribute('aria-valuetext', `${audioTime(audio.currentTime)} of ${audioTime(audio.duration)}`);
        audioCurrent.textContent = audioTime(audio.currentTime);
        audioDuration.textContent = audioTime(audio.duration);
        if (audioWave) audioWave.style.setProperty('--ac-audio-progress', `${percent}%`);
      }

      function updateAudioButton() {
        if (!audio || !audioToggle) return;
        const isPlaying = !audio.paused && !audio.ended;
        audioToggle.classList.toggle('is-playing', isPlaying);
        audioToggle.setAttribute('aria-label', `${isPlaying ? 'Pause' : 'Play'} ${audioName}`);
      }

      function showAudioError(message) {
        if (!audioStatus) return;
        audioStatus.textContent = message;
        audioStatus.hidden = false;
      }

      function renderAudioVisibility() {
        if (!audioSample) return;
        const showOnEbooks = audioSample.dataset.acAudioOnEbooks === 'true';
        const shouldShow = selectedFormatKey !== 'ebooks' || showOnEbooks;
        audioSample.hidden = !shouldShow;

        if (!shouldShow && audio && !audio.paused) {
          audio.pause();
        }
      }

      function setupAudioPlayer() {
        if (!audio || !audioUi || !audioToggle || !audioSeek) return;

        audio.controls = false;
        audio.hidden = true;
        audioUi.hidden = false;
        audioSeek.disabled = true;

        audioToggle.addEventListener('click', async () => {
          if (audio.paused || audio.ended) {
            if (audioStatus) audioStatus.hidden = true;
            try {
              await audio.play();
            } catch (error) {
              showAudioError('The sample could not start. Please check your connection and try again.');
            }
          } else {
            audio.pause();
          }
        });

        audioSeek.addEventListener('input', () => {
          if (!Number.isFinite(audio.duration) || audio.duration <= 0) return;
          audio.currentTime = (Number(audioSeek.value) / 100) * audio.duration;
          updateAudioProgress();
        });

        audio.addEventListener('loadedmetadata', updateAudioProgress);
        audio.addEventListener('durationchange', updateAudioProgress);
        audio.addEventListener('timeupdate', updateAudioProgress);
        audio.addEventListener('play', updateAudioButton);
        audio.addEventListener('pause', updateAudioButton);
        audio.addEventListener('ended', () => {
          updateAudioButton();
          updateAudioProgress();
        });
        audio.addEventListener('error', () => {
          audioToggle.disabled = true;
          audioSeek.disabled = true;
          showAudioError('This sample is temporarily unavailable.');
        });

        updateAudioButton();
        updateAudioProgress();
      }

      function renderVault() {
        const tier = earnedTier(selectedCents);
        const unlocked = tier ? formatData().tiers.findIndex((item) => item.key === tier.key) + 1 : 0;
        vaultCount.textContent = `Clout level ${unlocked}/3`;
        vaultProgress.style.width = `${unlocked <= 1 ? 0 : ((unlocked - 1) / 2) * 100}%`;
        vaultNodes.forEach((node, index) => {
          node.classList.toggle('is-unlocked', index < unlocked);
        });
        vaultTicks.forEach((tick, index) => {
          tick.classList.toggle('is-unlocked', unlocked >= index + 2);
        });
        vaultItems.forEach((item, index) => {
          item.classList.toggle('is-unlocked', index < unlocked);
        });
      }

      function renderMobileOffer() {
        if (!mobilePrice || !mobileClaim) return;
        const minimum = formatData().tiers[0].priceCents;
        const labels = mobileCopy.claims;
        mobileRetail.textContent = money(formatData().tiers[2].priceCents, config.currency);
        formatSummary.textContent = mobileCopy.titles[selectedFormatKey];
        const tooLow = Number.isInteger(selectedCents) && selectedCents < minimum && Boolean(mobilePrice.value.trim());
        mobileMinimum.textContent = money(minimum, config.currency) + ' minimum — Support indie authors ♥';
        mobileMinimum.hidden = !tooLow;
        mobilePrice.closest('.acpwyw2__price-field').classList.toggle('is-below-minimum', tooLow);
        const bonusTier = tierByKey('indulgent');
        const eligible = bonusTier && Number.isInteger(selectedCents) && selectedCents >= bonusTier.priceCents && !customerValidation();
        if (!eligible) selectedGift = null;
        giftPanel.classList.toggle('is-unlocked', Boolean(eligible));
        giftPanel.querySelector('[data-ac2-gift-heading]').textContent = eligible ? mobileCopy.giftUnlocked : mobileCopy.giftLocked.replace('{amount}', bonusTier ? money(bonusTier.priceCents, config.currency) : '');
        giftPanel.querySelector('[data-ac2-gift-note]').textContent = eligible
          ? (selectedGift ? selectedGift.title + ' — ' : '') + mobileCopy.giftIncluded
          : '';
        giftPanel.querySelector('[data-ac2-gift-note]').hidden = !eligible;
        giftButtons.forEach((button) => {
          button.disabled = !eligible || adding || !button.dataset.ac2GiftId;
          const selected = Boolean(selectedGift && selectedGift.handle === button.dataset.ac2GiftOption);
          button.setAttribute('aria-pressed', String(selected));
          button.classList.toggle('is-selected', selected);
        });
        mobilePrice.setAttribute('aria-label', 'Your price in US dollars. Minimum ' + money(minimum, config.currency));
        const message = mobilePrice.value.trim() && !tooLow ? customerValidation() : '';
        mobileError.textContent = message;
        mobileError.hidden = !message;
        mobilePrice.setAttribute('aria-invalid', String(tooLow || Boolean(message)));
        mobileClaim.disabled = !mobilePrice.value.trim() || Boolean(currentValidation()) || adding;
        mobileClaim.textContent = adding ? 'Building your order…' : labels[selectedFormatKey];
        mobileStatus.textContent = status.textContent;
        mobileStatus.hidden = !status.textContent;
      }

      function render() {
        const product = formatData();
        const retail = product.tiers[2].priceCents;
        const validation = currentValidation();
        const customerMessage = customerValidation();
        const hasPrice = Number.isInteger(selectedCents);

        formatButtons.forEach((button) => {
          button.setAttribute('aria-selected', String(button.dataset.acFormat === selectedFormatKey));
        });
        renderAudioVisibility();

        priceButtons.forEach((button) => {
          const key = button.dataset.acPriceChoice;
          const isCustom = key === 'custom';
          const tier = isCustom ? null : tierByKey(key);
          const selected = isCustom ? customMode : !customMode && key === selectedChoice;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
          button.disabled = isCustom ? false : !tier || !tier.id || !tier.available;
          const value = button.querySelector(`[data-ac-price-value="${key}"]`);
          if (value && tier) value.textContent = money(tier.priceCents, config.currency);
        });
        customCard.classList.toggle('is-selected', customMode);

        title.textContent = product.title;
        eyebrow.textContent = product.eyebrow;
        description.textContent = product.description;
        retailPrice.textContent = money(retail, config.currency);
        const minimum = product.tiers[0].priceCents;
        const minimumAmount = (minimum / 100).toFixed(2);
        const minimumPrompt = `${minimumAmount} minimum`;
        customInput.placeholder = customMode
          ? minimumPrompt
          : '';
        customInput.setAttribute('aria-label', `Your custom price in US dollars. Minimum ${money(minimum, config.currency)}.`);
        claimLabel.textContent = customMode && !hasPrice ? config.labels.enterPrice : product.claim;
        claimPrice.textContent = hasPrice ? money(selectedCents, config.currency) : config.labels.yourPrice;
        delivery.textContent = product.delivery;
        customCardCopy.textContent = customMode ? 'Support indie authors ♥' : product.customCopy;

        if (product.image) {
          productImage.src = product.image;
          productImage.alt = product.title;
        } else {
          productImage.removeAttribute('src');
          productImage.alt = '';
        }

        const hasCustomText = customInput.value.trim() !== '';
        errorMessage.hidden = !customerMessage || (customMode && !hasCustomText);
        errorMessage.textContent = customerMessage;
        claimButton.disabled = Boolean(validation) || adding;
        renderVault();
        renderMobileOffer();
      }

      function chooseFormat(key) {
        selectedFormatKey = key;
        selectedChoice = 'indulgent';
        selectedCents = formatData().tiers[1].priceCents;
        customMode = false;
        customInput.value = '';
        status.textContent = '';
        render();
      }

      function scrollMobileOfferIntoView() {
        const header = mobileMenu && mobileMenu.closest('.section-header-mobile');
        root.style.setProperty('--ac2-header-height', (header ? header.getBoundingClientRect().height : 69) + 'px');
        root.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
      function openMobileOffer(key) {
        selectedGift = null;
        chooseFormat(key);
        customMode = true;
        selectedChoice = 'custom';
        selectedCents = null;
        customInput.value = '';
        mobilePrice.value = '';
        const labels = mobileCopy.titles;
        detailTitle.textContent = labels[key];
        root.classList.add('is-ac2-detail');
        render();
        scrollMobileOfferIntoView();
        formatSummary.focus({ preventScroll: true });
      }
      formatEntryButtons.forEach((button) => {
        button.addEventListener('click', () => openMobileOffer(button.dataset.ac2Format));
      });
      if (backButton && mobileMenu) mobileMenu.parentElement.appendChild(backButton);
      if (backButton) backButton.addEventListener('click', () => {
        root.classList.remove('is-ac2-detail');
        scrollMobileOfferIntoView();
        if (mobileMenu) mobileMenu.focus({ preventScroll: true });
      });
      if (changeFormatButton) changeFormatButton.addEventListener('click', () => {
        root.classList.remove('is-ac2-detail');
        scrollMobileOfferIntoView();
        const currentChoice = formatEntryButtons.find(button => button.dataset.ac2Format === selectedFormatKey);
        if (currentChoice) currentChoice.focus({ preventScroll: true });
      });
      giftButtons.forEach(button => button.addEventListener('click', () => {
        if (button.disabled) return;
        selectedGift = { handle: button.dataset.ac2GiftOption, id: Number(button.dataset.ac2GiftId), title: button.dataset.ac2GiftTitle };
        renderMobileOffer();
      }));
      if (mobilePrice) mobilePrice.addEventListener('input', () => {
        customMode = true;
        selectedChoice = 'custom';
        customInput.value = mobilePrice.value;
        selectedCents = parseMoneyToCents(mobilePrice.value);
        status.textContent = '';
        render();
      });
      if (mobileClaim) mobileClaim.addEventListener('click', () => {
        if (mobileClaim.disabled) return;
        claimButton.click();
        renderMobileOffer();
      });
      if (mobilePrice) mobilePrice.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && !event.isComposing) {
          event.preventDefault();
          mobileClaim.click();
        }
      });
      const mobileStatusObserver = new MutationObserver(renderMobileOffer);
      mobileStatusObserver.observe(status, { childList: true, subtree: true });
      mobileStatusObserver.observe(claimButton, { attributes: true, attributeFilter: ['disabled'] });
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(root)) return;
        mobileStatusObserver.disconnect();
        if (backButton) backButton.remove();
      });

      formatButtons.forEach((button) => {
        button.addEventListener('click', () => chooseFormat(button.dataset.acFormat));
      });

      function activateCustomPrice() {
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        customMode = true;
        status.textContent = '';
        render();
        window.requestAnimationFrame(() => customInput.focus());
      }

      priceButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const key = button.dataset.acPriceChoice;
          if (key === 'custom') {
            activateCustomPrice();
            return;
          }

          const tier = tierByKey(key);
          if (!tier || !tier.id || !tier.available) return;
          selectedChoice = tier.key;
          selectedCents = tier.priceCents;
          customMode = false;
          customInput.value = '';
          status.textContent = '';
          render();
        });
      });

      customCard.addEventListener('click', (event) => {
        if (event.target.closest('[data-ac-price-choice="custom"]')) return;
        activateCustomPrice();
      });

      customInput.addEventListener('focus', () => {
        if (customMode) return;
        customMode = true;
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        status.textContent = '';
        render();
      });

      customInput.addEventListener('input', () => {
        customMode = true;
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        status.textContent = '';
        render();
      });

      customInput.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.isComposing) return;
        event.preventDefault();
        claimButton.click();
      });

      claimButton.addEventListener('click', async () => {
        if (adding) return;
        const validation = currentValidation();
        if (validation) {
          render();
          return;
        }

        const product = formatData();
        const tier = earnedTier(selectedCents);
        const parentPriceCents = Number.isInteger(tier.basePriceCents) ? tier.basePriceCents : tier.priceCents;
        const differenceCents = selectedCents - parentPriceCents;
        const dollarQuantity = Math.floor(differenceCents / 100);
        const centQuantity = differenceCents % 100;
        const purchaseGroup = groupId();
        const chosenPrice = `${money(selectedCents, config.currency)} ${config.currency}`;
        const accessLabels = {
          minimum: 'Complete Collection',
          indulgent: 'Certified Enabler',
          retail: 'Full Bonus Vault'
        };
        const accessLabel = accessLabels[tier.key] || 'Complete Collection';
        const items = [
          {
            id: Number(tier.id),
            quantity: 1,
            properties: {
              'Your price': chosenPrice,
              'Access': accessLabel,
              '_pwyw': 'true',
              '_pwyw_group': purchaseGroup,
              '_pwyw_format': selectedFormatKey,
              '_pwyw_tier': tier.key,
              '_pwyw_total_cents': String(selectedCents)
            }
          }
        ];

        if (dollarQuantity > 0) {
          items.push({
            id: Number(config.adjustments.dollar.id),
            quantity: dollarQuantity,
            parent_id: Number(tier.id),
            properties: {
              '_pwyw_adjustment': 'dollar',
              '_pwyw_group': purchaseGroup,
              '_pwyw_parent_variant_id': String(tier.id)
            }
          });
        }

        if (centQuantity > 0) {
          items.push({
            id: Number(config.adjustments.cent.id),
            quantity: centQuantity,
            parent_id: Number(tier.id),
            properties: {
              '_pwyw_adjustment': 'cent',
              '_pwyw_group': purchaseGroup,
              '_pwyw_parent_variant_id': String(tier.id)
            }
          });
        }

        const qualifiesForMobileGift = window.matchMedia('(max-width: 749px)').matches && root.classList.contains('is-ac2-detail') && selectedCents >= tierByKey('indulgent').priceCents;
        let mobileGift = qualifiesForMobileGift ? selectedGift : null;
        if (qualifiesForMobileGift && !mobileGift) {
          const defaultGiftButton = giftButtons.find(button => button.dataset.ac2GiftOption === 'a-night-by-my-fire');
          if (!defaultGiftButton || !Number(defaultGiftButton.dataset.ac2GiftId)) {
            status.textContent = 'Please choose an available bonus novella before continuing.';
            render();
            return;
          }
          mobileGift = { handle: defaultGiftButton.dataset.ac2GiftOption, id: Number(defaultGiftButton.dataset.ac2GiftId), title: defaultGiftButton.dataset.ac2GiftTitle };
          selectedGift = mobileGift;
        }
        if (mobileGift) {
          items.push({ id: mobileGift.id, quantity: 1, parent_id: Number(tier.id), properties: {
            '_pwyw_bonus': 'true', '_pwyw_group': purchaseGroup, '_pwyw_parent_variant_id': String(tier.id)
          }});
        }
        adding = true;
        claimButton.disabled = true;
        claimLabel.textContent = 'Building your order…';
        status.textContent = '';

        const storeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

        try {
          if (mobileGift) {
            const priorResponse = await fetch(storeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
            if (!priorResponse.ok) throw new Error('Could not verify your cart. Please try again.');
            const priorCart = await priorResponse.json();
            if (priorCart.items.some(item => item.properties && item.properties._pwyw_bonus === 'true')) {
              throw new Error('Your cart already has a bonus novella. Only one bonus is included per order. Please review your cart before adding another.');
            }
          }
          const response = await fetch(`${storeRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          });
          const payload = await response.json();

          if (!response.ok) {
            throw new Error(payload.description || payload.message || 'Shopify could not add this offer to the cart.');
          }

          if (mobileGift) {
            const verifiedResponse = await fetch(storeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
            if (!verifiedResponse.ok) throw new Error('Please review your cart to confirm the bonus is free before checking out.');
            const verifiedCart = await verifiedResponse.json();
            const addedGift = verifiedCart.items.find(item => item.properties && item.properties._pwyw_group === purchaseGroup && item.properties._pwyw_bonus === 'true');
            if (!addedGift || addedGift.final_line_price !== 0) {
              const updates = {};
              verifiedCart.items.filter(item => item.properties && item.properties._pwyw_group === purchaseGroup).forEach(item => { updates[item.key] = 0; });
              const rollback = await fetch(storeRoot + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
              if (!rollback.ok) throw new Error('Please review your cart before checkout: the bonus discount could not be confirmed.');
              throw new Error('The bonus discount could not be applied, possibly because of another discount in your cart. This offer was not added.');
            }
          }
          status.textContent = 'Offer added. Opening secure checkout…';
          const destination = config.destination === 'cart' ? 'cart' : 'checkout';
          window.location.assign(`${storeRoot}${destination}`);
        } catch (error) {
          adding = false;
          status.textContent = error && error.message
            ? error.message
            : 'Something interrupted the cart. Please try once more.';
          render();
        }
      });

      setupAudioPlayer();
      render();
    }

    function initializeAll(scope) {
      const container = scope || document;
      if (container.matches && container.matches(SELECTOR)) initialize(container);
      container.querySelectorAll(SELECTOR).forEach(initialize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac-pwyw-offer-2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-ac-pwyw2]';

    function money(cents, currency) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(cents / 100);
    }

    function parseMoneyToCents(rawValue) {
      const cleaned = String(rawValue || '').trim().replace(/[$\s]/g, '').replace(',', '.');
      if (!/^\d+(?:\.\d{0,2})?$/.test(cleaned)) return null;
      const parts = cleaned.split('.');
      const whole = Number(parts[0]);
      const fraction = Number((parts[1] || '').padEnd(2, '0'));
      if (!Number.isSafeInteger(whole) || whole < 0) return null;
      return (whole * 100) + fraction;
    }

    function groupId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return `pwyw-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }

    function initialize(root) {
      if (!root || root.dataset.acPwyw2Ready === 'true') return;

      const configNode = root.querySelector('[data-ac-pwyw2-config]');
      if (!configNode) return;

      let config;
      try {
        config = JSON.parse(configNode.textContent);
      } catch (error) {
        const visibleStatus = root.querySelector('[data-ac-role="status"]');
        if (visibleStatus) {
          visibleStatus.textContent = 'The offer configuration could not load. Please contact the store owner.';
        }
        root.querySelectorAll('button').forEach((button) => {
          button.disabled = true;
        });
        console.error('AC PWYW configuration error:', error);
        return;
      }
      root.dataset.acPwyw2Ready = 'true';

      const get = (role) => root.querySelector(`[data-ac-role="${role}"]`);
      const formatButtons = Array.from(root.querySelectorAll('[data-ac-format]'));
      const formatEntryButtons = Array.from(root.querySelectorAll('[data-ac2-format]'));
      const detailTitle = root.querySelector('[data-ac2-detail-title]');
      const backButton = root.querySelector('[data-ac2-back]');
      const mobilePrice = root.querySelector('[data-ac2-price]');
      const mobileMinimum = root.querySelector('[data-ac2-minimum]');
      const changeFormatButton = root.querySelector('[data-ac2-change-format]');
      const formatSummary = root.querySelector('[data-ac2-format-name]');
      const giftPanel = root.querySelector('[data-ac2-gift]');
      const giftButtons = Array.from(root.querySelectorAll('[data-ac2-gift-option]'));
      let selectedGift = null;
      const mobileRetail = root.querySelector('[data-ac2-retail]');
      const mobileError = root.querySelector('[data-ac2-error]');
      const mobileClaim = root.querySelector('[data-ac2-claim]');
      const mobileStatus = root.querySelector('[data-ac2-status]');
      const mobileMenu = document.querySelector('.item__mobile--hamburger > .mobileMenu-toggle');
      const mobileCopy = JSON.parse(root.querySelector('[data-ac2-copy]').textContent);

      const priceButtons = Array.from(root.querySelectorAll('[data-ac-price-choice]'));
      const vaultItems = Array.from(root.querySelectorAll('[data-ac-vault-item]'));
      const vaultNodes = Array.from(root.querySelectorAll('[data-ac-vault-node]'));
      const vaultTicks = Array.from(root.querySelectorAll('[data-ac-vault-tick]'));
      const title = get('title');
      const eyebrow = get('eyebrow');
      const description = get('description');
      const productImage = get('product-image');
      const retailPrice = get('retail-price');
      const customCard = root.querySelector('[data-ac-custom-card]');
      const customInput = get('custom-input');
      const customCardCopy = get('custom-card-copy');
      const errorMessage = get('error');
      const vaultCount = get('vault-count');
      const vaultProgress = get('vault-progress');
      const claimButton = get('claim');
      const claimLabel = get('claim-label');
      const claimPrice = get('claim-price');
      const delivery = get('delivery');
      const status = get('status');
      const audioSample = get('audio-sample');
      const audio = get('audio');
      const audioUi = get('audio-ui');
      const audioToggle = get('audio-toggle');
      const audioSeek = get('audio-seek');
      const audioCurrent = get('audio-current');
      const audioDuration = get('audio-duration');
      const audioStatus = get('audio-status');
      const audioWave = root.querySelector('[data-ac-audio-wave]');
      const audioName = 'audio sample';

      let selectedFormatKey = 'ebooks';
      let selectedChoice = 'indulgent';
      let selectedCents = config.formats.ebooks.tiers[1].priceCents;
      let customMode = false;
      let adding = false;

      function formatData() {
        return config.formats[selectedFormatKey];
      }

      function tierByKey(key) {
        return formatData().tiers.find((tier) => tier.key === key);
      }

      function earnedTier(amountCents) {
        return formatData().tiers
          .filter((tier) => tier.id && tier.available && amountCents >= tier.priceCents)
          .sort((a, b) => a.priceCents - b.priceCents)
          .pop() || null;
      }

      function configurationProblem() {
        if (config.currency !== 'USD') {
          return 'This first functional build checks out in USD. Please switch the store currency to USD.';
        }

        const missingTiers = formatData().tiers.some((tier) => !tier.id || !tier.available);
        if (missingTiers) {
          return 'This format is missing one or more matching, available price variants in the section settings.';
        }

        if (!config.adjustments.dollar.id || !config.adjustments.cent.id) {
          return 'Select the unlisted PWYW adjustment product in this section’s settings.';
        }

        if (!config.adjustments.dollar.available || !config.adjustments.cent.available) {
          return 'Both adjustment variants must be available for sale.';
        }

        if (config.adjustments.dollar.priceCents !== 100 || config.adjustments.cent.priceCents !== 1) {
          return 'The adjustment variants must be exactly $1.00 and $0.01 in USD.';
        }

        return '';
      }

      function customerValidation() {
        const minimum = formatData().tiers[0].priceCents;
        if (!Number.isInteger(selectedCents)) {
          return `Enter a price using no more than two decimal places.`;
        }
        if (selectedCents < minimum) {
          return `The minimum for this format is ${money(minimum, config.currency)}.`;
        }
        if (selectedCents > config.maximumCustomCents) {
          return `The maximum custom price is ${money(config.maximumCustomCents, config.currency)}.`;
        }
        return '';
      }

      function currentValidation() {
        const customerProblem = customerValidation();
        if (customerProblem) return customerProblem;
        if (!earnedTier(selectedCents)) {
          return 'The matching entitlement variant is unavailable.';
        }
        return configurationProblem();
      }

      function audioTime(seconds) {
        if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
        const wholeSeconds = Math.floor(seconds);
        const minutes = Math.floor(wholeSeconds / 60);
        const remainder = String(wholeSeconds % 60).padStart(2, '0');
        return `${minutes}:${remainder}`;
      }

      function updateAudioProgress() {
        if (!audio || !audioSeek || !audioCurrent || !audioDuration) return;
        const hasDuration = Number.isFinite(audio.duration) && audio.duration > 0;
        const percent = hasDuration ? Math.min(100, Math.max(0, (audio.currentTime / audio.duration) * 100)) : 0;

        audioSeek.value = String(percent);
        audioSeek.disabled = !hasDuration;
        audioSeek.setAttribute('aria-valuetext', `${audioTime(audio.currentTime)} of ${audioTime(audio.duration)}`);
        audioCurrent.textContent = audioTime(audio.currentTime);
        audioDuration.textContent = audioTime(audio.duration);
        if (audioWave) audioWave.style.setProperty('--ac-audio-progress', `${percent}%`);
      }

      function updateAudioButton() {
        if (!audio || !audioToggle) return;
        const isPlaying = !audio.paused && !audio.ended;
        audioToggle.classList.toggle('is-playing', isPlaying);
        audioToggle.setAttribute('aria-label', `${isPlaying ? 'Pause' : 'Play'} ${audioName}`);
      }

      function showAudioError(message) {
        if (!audioStatus) return;
        audioStatus.textContent = message;
        audioStatus.hidden = false;
      }

      function renderAudioVisibility() {
        if (!audioSample) return;
        const showOnEbooks = audioSample.dataset.acAudioOnEbooks === 'true';
        const shouldShow = selectedFormatKey !== 'ebooks' || showOnEbooks;
        audioSample.hidden = !shouldShow;

        if (!shouldShow && audio && !audio.paused) {
          audio.pause();
        }
      }

      function setupAudioPlayer() {
        if (!audio || !audioUi || !audioToggle || !audioSeek) return;

        audio.controls = false;
        audio.hidden = true;
        audioUi.hidden = false;
        audioSeek.disabled = true;

        audioToggle.addEventListener('click', async () => {
          if (audio.paused || audio.ended) {
            if (audioStatus) audioStatus.hidden = true;
            try {
              await audio.play();
            } catch (error) {
              showAudioError('The sample could not start. Please check your connection and try again.');
            }
          } else {
            audio.pause();
          }
        });

        audioSeek.addEventListener('input', () => {
          if (!Number.isFinite(audio.duration) || audio.duration <= 0) return;
          audio.currentTime = (Number(audioSeek.value) / 100) * audio.duration;
          updateAudioProgress();
        });

        audio.addEventListener('loadedmetadata', updateAudioProgress);
        audio.addEventListener('durationchange', updateAudioProgress);
        audio.addEventListener('timeupdate', updateAudioProgress);
        audio.addEventListener('play', updateAudioButton);
        audio.addEventListener('pause', updateAudioButton);
        audio.addEventListener('ended', () => {
          updateAudioButton();
          updateAudioProgress();
        });
        audio.addEventListener('error', () => {
          audioToggle.disabled = true;
          audioSeek.disabled = true;
          showAudioError('This sample is temporarily unavailable.');
        });

        updateAudioButton();
        updateAudioProgress();
      }

      function renderVault() {
        const tier = earnedTier(selectedCents);
        const unlocked = tier ? formatData().tiers.findIndex((item) => item.key === tier.key) + 1 : 0;
        vaultCount.textContent = `Clout level ${unlocked}/3`;
        vaultProgress.style.width = `${unlocked <= 1 ? 0 : ((unlocked - 1) / 2) * 100}%`;
        vaultNodes.forEach((node, index) => {
          node.classList.toggle('is-unlocked', index < unlocked);
        });
        vaultTicks.forEach((tick, index) => {
          tick.classList.toggle('is-unlocked', unlocked >= index + 2);
        });
        vaultItems.forEach((item, index) => {
          item.classList.toggle('is-unlocked', index < unlocked);
        });
      }

      function renderMobileOffer() {
        if (!mobilePrice || !mobileClaim) return;
        const minimum = formatData().tiers[0].priceCents;
        const labels = mobileCopy.claims;
        mobileRetail.textContent = money(formatData().tiers[2].priceCents, config.currency);
        formatSummary.textContent = mobileCopy.titles[selectedFormatKey];
        const tooLow = Number.isInteger(selectedCents) && selectedCents < minimum && Boolean(mobilePrice.value.trim());
        mobileMinimum.textContent = money(minimum, config.currency) + ' minimum — Support indie authors ♥';
        mobileMinimum.hidden = !tooLow;
        mobilePrice.closest('.acpwyw2__price-field').classList.toggle('is-below-minimum', tooLow);
        const bonusTier = tierByKey('indulgent');
        const eligible = bonusTier && Number.isInteger(selectedCents) && selectedCents >= bonusTier.priceCents && !customerValidation();
        if (!eligible) selectedGift = null;
        giftPanel.classList.toggle('is-unlocked', Boolean(eligible));
        giftPanel.querySelector('[data-ac2-gift-heading]').textContent = eligible ? mobileCopy.giftUnlocked : mobileCopy.giftLocked.replace('{amount}', bonusTier ? money(bonusTier.priceCents, config.currency) : '');
        giftPanel.querySelector('[data-ac2-gift-note]').textContent = eligible
          ? (selectedGift ? selectedGift.title + ' — ' : '') + mobileCopy.giftIncluded
          : '';
        giftPanel.querySelector('[data-ac2-gift-note]').hidden = !eligible;
        giftButtons.forEach((button) => {
          button.disabled = !eligible || adding || !button.dataset.ac2GiftId;
          const selected = Boolean(selectedGift && selectedGift.handle === button.dataset.ac2GiftOption);
          button.setAttribute('aria-pressed', String(selected));
          button.classList.toggle('is-selected', selected);
        });
        mobilePrice.setAttribute('aria-label', 'Your price in US dollars. Minimum ' + money(minimum, config.currency));
        const message = mobilePrice.value.trim() && !tooLow ? customerValidation() : '';
        mobileError.textContent = message;
        mobileError.hidden = !message;
        mobilePrice.setAttribute('aria-invalid', String(tooLow || Boolean(message)));
        mobileClaim.disabled = !mobilePrice.value.trim() || Boolean(currentValidation()) || adding;
        mobileClaim.textContent = adding ? 'Building your order…' : labels[selectedFormatKey];
        mobileStatus.textContent = status.textContent;
        mobileStatus.hidden = !status.textContent;
      }

      function render() {
        const product = formatData();
        const retail = product.tiers[2].priceCents;
        const validation = currentValidation();
        const customerMessage = customerValidation();
        const hasPrice = Number.isInteger(selectedCents);

        formatButtons.forEach((button) => {
          button.setAttribute('aria-selected', String(button.dataset.acFormat === selectedFormatKey));
        });
        renderAudioVisibility();

        priceButtons.forEach((button) => {
          const key = button.dataset.acPriceChoice;
          const isCustom = key === 'custom';
          const tier = isCustom ? null : tierByKey(key);
          const selected = isCustom ? customMode : !customMode && key === selectedChoice;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
          button.disabled = isCustom ? false : !tier || !tier.id || !tier.available;
          const value = button.querySelector(`[data-ac-price-value="${key}"]`);
          if (value && tier) value.textContent = money(tier.priceCents, config.currency);
        });
        customCard.classList.toggle('is-selected', customMode);

        title.textContent = product.title;
        eyebrow.textContent = product.eyebrow;
        description.textContent = product.description;
        retailPrice.textContent = money(retail, config.currency);
        const minimum = product.tiers[0].priceCents;
        const minimumAmount = (minimum / 100).toFixed(2);
        const minimumPrompt = `${minimumAmount} minimum`;
        customInput.placeholder = customMode
          ? minimumPrompt
          : '';
        customInput.setAttribute('aria-label', `Your custom price in US dollars. Minimum ${money(minimum, config.currency)}.`);
        claimLabel.textContent = customMode && !hasPrice ? config.labels.enterPrice : product.claim;
        claimPrice.textContent = hasPrice ? money(selectedCents, config.currency) : config.labels.yourPrice;
        delivery.textContent = product.delivery;
        customCardCopy.textContent = customMode ? 'Support indie authors ♥' : product.customCopy;

        if (product.image) {
          productImage.src = product.image;
          productImage.alt = product.title;
        } else {
          productImage.removeAttribute('src');
          productImage.alt = '';
        }

        const hasCustomText = customInput.value.trim() !== '';
        errorMessage.hidden = !customerMessage || (customMode && !hasCustomText);
        errorMessage.textContent = customerMessage;
        claimButton.disabled = Boolean(validation) || adding;
        renderVault();
        renderMobileOffer();
      }

      function chooseFormat(key) {
        selectedFormatKey = key;
        selectedChoice = 'indulgent';
        selectedCents = formatData().tiers[1].priceCents;
        customMode = false;
        customInput.value = '';
        status.textContent = '';
        render();
      }

      function scrollMobileOfferIntoView() {
        const header = mobileMenu && mobileMenu.closest('.section-header-mobile');
        root.style.setProperty('--ac2-header-height', (header ? header.getBoundingClientRect().height : 69) + 'px');
        root.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
      function openMobileOffer(key) {
        selectedGift = null;
        chooseFormat(key);
        customMode = true;
        selectedChoice = 'custom';
        selectedCents = null;
        customInput.value = '';
        mobilePrice.value = '';
        const labels = mobileCopy.titles;
        detailTitle.textContent = labels[key];
        root.classList.add('is-ac2-detail');
        render();
        scrollMobileOfferIntoView();
        formatSummary.focus({ preventScroll: true });
      }
      formatEntryButtons.forEach((button) => {
        button.addEventListener('click', () => openMobileOffer(button.dataset.ac2Format));
      });
      if (backButton && mobileMenu) mobileMenu.parentElement.appendChild(backButton);
      if (backButton) backButton.addEventListener('click', () => {
        root.classList.remove('is-ac2-detail');
        scrollMobileOfferIntoView();
        if (mobileMenu) mobileMenu.focus({ preventScroll: true });
      });
      if (changeFormatButton) changeFormatButton.addEventListener('click', () => {
        root.classList.remove('is-ac2-detail');
        scrollMobileOfferIntoView();
        const currentChoice = formatEntryButtons.find(button => button.dataset.ac2Format === selectedFormatKey);
        if (currentChoice) currentChoice.focus({ preventScroll: true });
      });
      giftButtons.forEach(button => button.addEventListener('click', () => {
        if (button.disabled) return;
        selectedGift = { handle: button.dataset.ac2GiftOption, id: Number(button.dataset.ac2GiftId), title: button.dataset.ac2GiftTitle };
        renderMobileOffer();
      }));
      if (mobilePrice) mobilePrice.addEventListener('input', () => {
        customMode = true;
        selectedChoice = 'custom';
        customInput.value = mobilePrice.value;
        selectedCents = parseMoneyToCents(mobilePrice.value);
        status.textContent = '';
        render();
      });
      if (mobileClaim) mobileClaim.addEventListener('click', () => {
        if (mobileClaim.disabled) return;
        claimButton.click();
        renderMobileOffer();
      });
      if (mobilePrice) mobilePrice.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && !event.isComposing) {
          event.preventDefault();
          mobileClaim.click();
        }
      });
      const mobileStatusObserver = new MutationObserver(renderMobileOffer);
      mobileStatusObserver.observe(status, { childList: true, subtree: true });
      mobileStatusObserver.observe(claimButton, { attributes: true, attributeFilter: ['disabled'] });
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(root)) return;
        mobileStatusObserver.disconnect();
        if (backButton) backButton.remove();
      });

      formatButtons.forEach((button) => {
        button.addEventListener('click', () => chooseFormat(button.dataset.acFormat));
      });

      function activateCustomPrice() {
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        customMode = true;
        status.textContent = '';
        render();
        window.requestAnimationFrame(() => customInput.focus());
      }

      priceButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const key = button.dataset.acPriceChoice;
          if (key === 'custom') {
            activateCustomPrice();
            return;
          }

          const tier = tierByKey(key);
          if (!tier || !tier.id || !tier.available) return;
          selectedChoice = tier.key;
          selectedCents = tier.priceCents;
          customMode = false;
          customInput.value = '';
          status.textContent = '';
          render();
        });
      });

      customCard.addEventListener('click', (event) => {
        if (event.target.closest('[data-ac-price-choice="custom"]')) return;
        activateCustomPrice();
      });

      customInput.addEventListener('focus', () => {
        if (customMode) return;
        customMode = true;
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        status.textContent = '';
        render();
      });

      customInput.addEventListener('input', () => {
        customMode = true;
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        status.textContent = '';
        render();
      });

      customInput.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.isComposing) return;
        event.preventDefault();
        claimButton.click();
      });

      claimButton.addEventListener('click', async () => {
        if (adding) return;
        const validation = currentValidation();
        if (validation) {
          render();
          return;
        }

        const product = formatData();
        const tier = earnedTier(selectedCents);
        const parentPriceCents = Number.isInteger(tier.basePriceCents) ? tier.basePriceCents : tier.priceCents;
        const differenceCents = selectedCents - parentPriceCents;
        const dollarQuantity = Math.floor(differenceCents / 100);
        const centQuantity = differenceCents % 100;
        const purchaseGroup = groupId();
        const chosenPrice = `${money(selectedCents, config.currency)} ${config.currency}`;
        const accessLabels = {
          minimum: 'Complete Collection',
          indulgent: 'Certified Enabler',
          retail: 'Full Bonus Vault'
        };
        const accessLabel = accessLabels[tier.key] || 'Complete Collection';
        const items = [
          {
            id: Number(tier.id),
            quantity: 1,
            properties: {
              'Your price': chosenPrice,
              'Access': accessLabel,
              '_pwyw': 'true',
              '_pwyw_group': purchaseGroup,
              '_pwyw_format': selectedFormatKey,
              '_pwyw_tier': tier.key,
              '_pwyw_total_cents': String(selectedCents)
            }
          }
        ];

        if (dollarQuantity > 0) {
          items.push({
            id: Number(config.adjustments.dollar.id),
            quantity: dollarQuantity,
            parent_id: Number(tier.id),
            properties: {
              '_pwyw_adjustment': 'dollar',
              '_pwyw_group': purchaseGroup,
              '_pwyw_parent_variant_id': String(tier.id)
            }
          });
        }

        if (centQuantity > 0) {
          items.push({
            id: Number(config.adjustments.cent.id),
            quantity: centQuantity,
            parent_id: Number(tier.id),
            properties: {
              '_pwyw_adjustment': 'cent',
              '_pwyw_group': purchaseGroup,
              '_pwyw_parent_variant_id': String(tier.id)
            }
          });
        }

        const qualifiesForMobileGift = window.matchMedia('(max-width: 749px)').matches && root.classList.contains('is-ac2-detail') && selectedCents >= tierByKey('indulgent').priceCents;
        let mobileGift = qualifiesForMobileGift ? selectedGift : null;
        if (qualifiesForMobileGift && !mobileGift) {
          const defaultGiftButton = giftButtons.find(button => button.dataset.ac2GiftOption === 'a-night-by-my-fire');
          if (!defaultGiftButton || !Number(defaultGiftButton.dataset.ac2GiftId)) {
            status.textContent = 'Please choose an available bonus novella before continuing.';
            render();
            return;
          }
          mobileGift = { handle: defaultGiftButton.dataset.ac2GiftOption, id: Number(defaultGiftButton.dataset.ac2GiftId), title: defaultGiftButton.dataset.ac2GiftTitle };
          selectedGift = mobileGift;
        }
        if (mobileGift) {
          items.push({ id: mobileGift.id, quantity: 1, parent_id: Number(tier.id), properties: {
            '_pwyw_bonus': 'true', '_pwyw_group': purchaseGroup, '_pwyw_parent_variant_id': String(tier.id)
          }});
        }
        adding = true;
        claimButton.disabled = true;
        claimLabel.textContent = 'Building your order…';
        status.textContent = '';

        const storeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

        try {
          if (mobileGift) {
            const priorResponse = await fetch(storeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
            if (!priorResponse.ok) throw new Error('Could not verify your cart. Please try again.');
            const priorCart = await priorResponse.json();
            if (priorCart.items.some(item => item.properties && item.properties._pwyw_bonus === 'true')) {
              throw new Error('Your cart already has a bonus novella. Only one bonus is included per order. Please review your cart before adding another.');
            }
          }
          const response = await fetch(`${storeRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          });
          const payload = await response.json();

          if (!response.ok) {
            throw new Error(payload.description || payload.message || 'Shopify could not add this offer to the cart.');
          }

          if (mobileGift) {
            const verifiedResponse = await fetch(storeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
            if (!verifiedResponse.ok) throw new Error('Please review your cart to confirm the bonus is free before checking out.');
            const verifiedCart = await verifiedResponse.json();
            const addedGift = verifiedCart.items.find(item => item.properties && item.properties._pwyw_group === purchaseGroup && item.properties._pwyw_bonus === 'true');
            if (!addedGift || addedGift.final_line_price !== 0) {
              const updates = {};
              verifiedCart.items.filter(item => item.properties && item.properties._pwyw_group === purchaseGroup).forEach(item => { updates[item.key] = 0; });
              const rollback = await fetch(storeRoot + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
              if (!rollback.ok) throw new Error('Please review your cart before checkout: the bonus discount could not be confirmed.');
              throw new Error('The bonus discount could not be applied, possibly because of another discount in your cart. This offer was not added.');
            }
          }
          status.textContent = 'Offer added. Opening secure checkout…';
          const destination = config.destination === 'cart' ? 'cart' : 'checkout';
          window.location.assign(`${storeRoot}${destination}`);
        } catch (error) {
          adding = false;
          status.textContent = error && error.message
            ? error.message
            : 'Something interrupted the cart. Please try once more.';
          render();
        }
      });

      setupAudioPlayer();
      render();
    }

    function initializeAll(scope) {
      const container = scope || document;
      if (container.matches && container.matches(SELECTOR)) initialize(container);
      container.querySelectorAll(SELECTOR).forEach(initialize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac-pwyw-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-ac-pwyw]';

    function money(cents, currency) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(cents / 100);
    }

    function parseMoneyToCents(rawValue) {
      const cleaned = String(rawValue || '').trim().replace(/[$\s]/g, '').replace(',', '.');
      if (!/^\d+(?:\.\d{0,2})?$/.test(cleaned)) return null;
      const parts = cleaned.split('.');
      const whole = Number(parts[0]);
      const fraction = Number((parts[1] || '').padEnd(2, '0'));
      if (!Number.isSafeInteger(whole) || whole < 0) return null;
      return (whole * 100) + fraction;
    }

    function groupId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return `pwyw-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }

    function initialize(root) {
      if (!root || root.dataset.acPwywReady === 'true') return;

      const configNode = root.querySelector('[data-ac-pwyw-config]');
      if (!configNode) return;

      let config;
      try {
        config = JSON.parse(configNode.textContent);
      } catch (error) {
        const visibleStatus = root.querySelector('[data-ac-role="status"]');
        if (visibleStatus) {
          visibleStatus.textContent = 'The offer configuration could not load. Please contact the store owner.';
        }
        root.querySelectorAll('button').forEach((button) => {
          button.disabled = true;
        });
        console.error('AC PWYW configuration error:', error);
        return;
      }
      root.dataset.acPwywReady = 'true';

      const get = (role) => root.querySelector(`[data-ac-role="${role}"]`);
      const formatButtons = Array.from(root.querySelectorAll('[data-ac-format]'));
      const priceButtons = Array.from(root.querySelectorAll('[data-ac-price-choice]'));
      const vaultItems = Array.from(root.querySelectorAll('[data-ac-vault-item]'));
      const vaultNodes = Array.from(root.querySelectorAll('[data-ac-vault-node]'));
      const vaultTicks = Array.from(root.querySelectorAll('[data-ac-vault-tick]'));
      const title = get('title');
      const eyebrow = get('eyebrow');
      const description = get('description');
      const productImage = get('product-image');
      const retailPrice = get('retail-price');
      const customCard = root.querySelector('[data-ac-custom-card]');
      const customInput = get('custom-input');
      const customCardCopy = get('custom-card-copy');
      const errorMessage = get('error');
      const vaultCount = get('vault-count');
      const vaultProgress = get('vault-progress');
      const claimButton = get('claim');
      const claimLabel = get('claim-label');
      const claimPrice = get('claim-price');
      const delivery = get('delivery');
      const status = get('status');
      const audioSample = get('audio-sample');
      const audio = get('audio');
      const audioUi = get('audio-ui');
      const audioToggle = get('audio-toggle');
      const audioSeek = get('audio-seek');
      const audioCurrent = get('audio-current');
      const audioDuration = get('audio-duration');
      const audioStatus = get('audio-status');
      const audioWave = root.querySelector('[data-ac-audio-wave]');
      const audioName = 'audio sample';

      let selectedFormatKey = 'ebooks';
      let selectedChoice = 'indulgent';
      let selectedCents = config.formats.ebooks.tiers[1].priceCents;
      let customMode = false;
      let adding = false;

      function formatData() {
        return config.formats[selectedFormatKey];
      }

      function tierByKey(key) {
        return formatData().tiers.find((tier) => tier.key === key);
      }

      function earnedTier(amountCents) {
        return formatData().tiers
          .filter((tier) => tier.id && tier.available && amountCents >= tier.priceCents)
          .sort((a, b) => a.priceCents - b.priceCents)
          .pop() || null;
      }

      function configurationProblem() {
        if (config.currency !== 'USD') {
          return 'This first functional build checks out in USD. Please switch the store currency to USD.';
        }

        const missingTiers = formatData().tiers.some((tier) => !tier.id || !tier.available);
        if (missingTiers) {
          return 'This format is missing one or more matching, available price variants in the section settings.';
        }

        if (!config.adjustments.dollar.id || !config.adjustments.cent.id) {
          return 'Select the unlisted PWYW adjustment product in this section’s settings.';
        }

        if (!config.adjustments.dollar.available || !config.adjustments.cent.available) {
          return 'Both adjustment variants must be available for sale.';
        }

        if (config.adjustments.dollar.priceCents !== 100 || config.adjustments.cent.priceCents !== 1) {
          return 'The adjustment variants must be exactly $1.00 and $0.01 in USD.';
        }

        return '';
      }

      function customerValidation() {
        const minimum = formatData().tiers[0].priceCents;
        if (!Number.isInteger(selectedCents)) {
          return `Enter a price using no more than two decimal places.`;
        }
        if (selectedCents < minimum) {
          return `The minimum for this format is ${money(minimum, config.currency)}.`;
        }
        if (selectedCents > config.maximumCustomCents) {
          return `The maximum custom price is ${money(config.maximumCustomCents, config.currency)}.`;
        }
        return '';
      }

      function currentValidation() {
        const customerProblem = customerValidation();
        if (customerProblem) return customerProblem;
        if (!earnedTier(selectedCents)) {
          return 'The matching entitlement variant is unavailable.';
        }
        return configurationProblem();
      }

      function audioTime(seconds) {
        if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
        const wholeSeconds = Math.floor(seconds);
        const minutes = Math.floor(wholeSeconds / 60);
        const remainder = String(wholeSeconds % 60).padStart(2, '0');
        return `${minutes}:${remainder}`;
      }

      function updateAudioProgress() {
        if (!audio || !audioSeek || !audioCurrent || !audioDuration) return;
        const hasDuration = Number.isFinite(audio.duration) && audio.duration > 0;
        const percent = hasDuration ? Math.min(100, Math.max(0, (audio.currentTime / audio.duration) * 100)) : 0;

        audioSeek.value = String(percent);
        audioSeek.disabled = !hasDuration;
        audioSeek.setAttribute('aria-valuetext', `${audioTime(audio.currentTime)} of ${audioTime(audio.duration)}`);
        audioCurrent.textContent = audioTime(audio.currentTime);
        audioDuration.textContent = audioTime(audio.duration);
        if (audioWave) audioWave.style.setProperty('--ac-audio-progress', `${percent}%`);
      }

      function updateAudioButton() {
        if (!audio || !audioToggle) return;
        const isPlaying = !audio.paused && !audio.ended;
        audioToggle.classList.toggle('is-playing', isPlaying);
        audioToggle.setAttribute('aria-label', `${isPlaying ? 'Pause' : 'Play'} ${audioName}`);
      }

      function showAudioError(message) {
        if (!audioStatus) return;
        audioStatus.textContent = message;
        audioStatus.hidden = false;
      }

      function renderAudioVisibility() {
        if (!audioSample) return;
        const showOnEbooks = audioSample.dataset.acAudioOnEbooks === 'true';
        const shouldShow = selectedFormatKey !== 'ebooks' || showOnEbooks;
        audioSample.hidden = !shouldShow;

        if (!shouldShow && audio && !audio.paused) {
          audio.pause();
        }
      }

      function setupAudioPlayer() {
        if (!audio || !audioUi || !audioToggle || !audioSeek) return;

        audio.controls = false;
        audio.hidden = true;
        audioUi.hidden = false;
        audioSeek.disabled = true;

        audioToggle.addEventListener('click', async () => {
          if (audio.paused || audio.ended) {
            if (audioStatus) audioStatus.hidden = true;
            try {
              await audio.play();
            } catch (error) {
              showAudioError('The sample could not start. Please check your connection and try again.');
            }
          } else {
            audio.pause();
          }
        });

        audioSeek.addEventListener('input', () => {
          if (!Number.isFinite(audio.duration) || audio.duration <= 0) return;
          audio.currentTime = (Number(audioSeek.value) / 100) * audio.duration;
          updateAudioProgress();
        });

        audio.addEventListener('loadedmetadata', updateAudioProgress);
        audio.addEventListener('durationchange', updateAudioProgress);
        audio.addEventListener('timeupdate', updateAudioProgress);
        audio.addEventListener('play', updateAudioButton);
        audio.addEventListener('pause', updateAudioButton);
        audio.addEventListener('ended', () => {
          updateAudioButton();
          updateAudioProgress();
        });
        audio.addEventListener('error', () => {
          audioToggle.disabled = true;
          audioSeek.disabled = true;
          showAudioError('This sample is temporarily unavailable.');
        });

        updateAudioButton();
        updateAudioProgress();
      }

      function renderVault() {
        const tier = earnedTier(selectedCents);
        const unlocked = tier ? formatData().tiers.findIndex((item) => item.key === tier.key) + 1 : 0;
        vaultCount.textContent = `Clout level ${unlocked}/3`;
        vaultProgress.style.width = `${unlocked <= 1 ? 0 : ((unlocked - 1) / 2) * 100}%`;
        vaultNodes.forEach((node, index) => {
          node.classList.toggle('is-unlocked', index < unlocked);
        });
        vaultTicks.forEach((tick, index) => {
          tick.classList.toggle('is-unlocked', unlocked >= index + 2);
        });
        vaultItems.forEach((item, index) => {
          item.classList.toggle('is-unlocked', index < unlocked);
        });
      }

      function render() {
        const product = formatData();
        const retail = product.tiers[2].priceCents;
        const validation = currentValidation();
        const customerMessage = customerValidation();
        const hasPrice = Number.isInteger(selectedCents);

        formatButtons.forEach((button) => {
          button.setAttribute('aria-selected', String(button.dataset.acFormat === selectedFormatKey));
        });
        renderAudioVisibility();

        priceButtons.forEach((button) => {
          const key = button.dataset.acPriceChoice;
          const isCustom = key === 'custom';
          const tier = isCustom ? null : tierByKey(key);
          const selected = isCustom ? customMode : !customMode && key === selectedChoice;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
          button.disabled = isCustom ? false : !tier || !tier.id || !tier.available;
          const value = button.querySelector(`[data-ac-price-value="${key}"]`);
          if (value && tier) value.textContent = money(tier.priceCents, config.currency);
        });
        customCard.classList.toggle('is-selected', customMode);

        title.textContent = product.title;
        eyebrow.textContent = product.eyebrow;
        description.textContent = product.description;
        retailPrice.textContent = money(retail, config.currency);
        const minimum = product.tiers[0].priceCents;
        const minimumAmount = (minimum / 100).toFixed(2);
        const minimumPrompt = `${minimumAmount} minimum`;
        customInput.placeholder = customMode
          ? minimumPrompt
          : '';
        customInput.setAttribute('aria-label', `Your custom price in US dollars. Minimum ${money(minimum, config.currency)}.`);
        claimLabel.textContent = customMode && !hasPrice ? config.labels.enterPrice : product.claim;
        claimPrice.textContent = hasPrice ? money(selectedCents, config.currency) : config.labels.yourPrice;
        delivery.textContent = product.delivery;
        customCardCopy.textContent = customMode ? 'Support indie authors ♥' : product.customCopy;

        if (product.image) {
          productImage.src = product.image;
          productImage.alt = product.title;
        } else {
          productImage.removeAttribute('src');
          productImage.alt = '';
        }

        const hasCustomText = customInput.value.trim() !== '';
        errorMessage.hidden = !customerMessage || (customMode && !hasCustomText);
        errorMessage.textContent = customerMessage;
        claimButton.disabled = Boolean(validation) || adding;
        renderVault();
      }

      function chooseFormat(key) {
        selectedFormatKey = key;
        selectedChoice = 'indulgent';
        selectedCents = formatData().tiers[1].priceCents;
        customMode = false;
        customInput.value = '';
        status.textContent = '';
        render();
      }

      formatButtons.forEach((button) => {
        button.addEventListener('click', () => chooseFormat(button.dataset.acFormat));
      });

      function activateCustomPrice() {
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        customMode = true;
        status.textContent = '';
        render();
        window.requestAnimationFrame(() => customInput.focus());
      }

      priceButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const key = button.dataset.acPriceChoice;
          if (key === 'custom') {
            activateCustomPrice();
            return;
          }

          const tier = tierByKey(key);
          if (!tier || !tier.id || !tier.available) return;
          selectedChoice = tier.key;
          selectedCents = tier.priceCents;
          customMode = false;
          customInput.value = '';
          status.textContent = '';
          render();
        });
      });

      customCard.addEventListener('click', (event) => {
        if (event.target.closest('[data-ac-price-choice="custom"]')) return;
        activateCustomPrice();
      });

      customInput.addEventListener('focus', () => {
        if (customMode) return;
        customMode = true;
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        status.textContent = '';
        render();
      });

      customInput.addEventListener('input', () => {
        customMode = true;
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        status.textContent = '';
        render();
      });

      customInput.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.isComposing) return;
        event.preventDefault();
        claimButton.click();
      });

      claimButton.addEventListener('click', async () => {
        if (adding) return;
        const validation = currentValidation();
        if (validation) {
          render();
          return;
        }

        const product = formatData();
        const tier = earnedTier(selectedCents);
        const parentPriceCents = Number.isInteger(tier.basePriceCents) ? tier.basePriceCents : tier.priceCents;
        const differenceCents = selectedCents - parentPriceCents;
        const dollarQuantity = Math.floor(differenceCents / 100);
        const centQuantity = differenceCents % 100;
        const purchaseGroup = groupId();
        const chosenPrice = `${money(selectedCents, config.currency)} ${config.currency}`;
        const accessLabels = {
          minimum: 'Complete Collection',
          indulgent: 'Certified Enabler',
          retail: 'Full Bonus Vault'
        };
        const accessLabel = accessLabels[tier.key] || 'Complete Collection';
        const items = [
          {
            id: Number(tier.id),
            quantity: 1,
            properties: {
              'Your price': chosenPrice,
              'Access': accessLabel,
              '_pwyw': 'true',
              '_pwyw_group': purchaseGroup,
              '_pwyw_format': selectedFormatKey,
              '_pwyw_tier': tier.key,
              '_pwyw_total_cents': String(selectedCents)
            }
          }
        ];

        if (dollarQuantity > 0) {
          items.push({
            id: Number(config.adjustments.dollar.id),
            quantity: dollarQuantity,
            parent_id: Number(tier.id),
            properties: {
              '_pwyw_adjustment': 'dollar',
              '_pwyw_group': purchaseGroup,
              '_pwyw_parent_variant_id': String(tier.id)
            }
          });
        }

        if (centQuantity > 0) {
          items.push({
            id: Number(config.adjustments.cent.id),
            quantity: centQuantity,
            parent_id: Number(tier.id),
            properties: {
              '_pwyw_adjustment': 'cent',
              '_pwyw_group': purchaseGroup,
              '_pwyw_parent_variant_id': String(tier.id)
            }
          });
        }

        adding = true;
        claimButton.disabled = true;
        claimLabel.textContent = 'Building your order…';
        status.textContent = '';

        const storeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

        try {
          const response = await fetch(`${storeRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          });
          const payload = await response.json();

          if (!response.ok) {
            throw new Error(payload.description || payload.message || 'Shopify could not add this offer to the cart.');
          }

          status.textContent = 'Offer added. Opening secure checkout…';
          const destination = config.destination === 'cart' ? 'cart' : 'checkout';
          window.location.assign(`${storeRoot}${destination}`);
        } catch (error) {
          adding = false;
          status.textContent = error && error.message
            ? error.message
            : 'Something interrupted the cart. Please try once more.';
          render();
        }
      });

      setupAudioPlayer();
      render();
    }

    function initializeAll(scope) {
      const container = scope || document;
      if (container.matches && container.matches(SELECTOR)) initialize(container);
      container.querySelectorAll(SELECTOR).forEach(initialize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["addison-cain-pwyw-home-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-ac-pwyw-home]';

    function money(cents, currency) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(cents / 100);
    }

    function parseMoneyToCents(rawValue) {
      const cleaned = String(rawValue || '').trim().replace(/[$,\s]/g, '');
      if (!/^\d+(?:\.\d{0,2})?$/.test(cleaned)) return null;
      const parts = cleaned.split('.');
      const whole = Number(parts[0]);
      const fraction = Number((parts[1] || '').padEnd(2, '0'));
      if (!Number.isSafeInteger(whole) || whole < 0) return null;
      return (whole * 100) + fraction;
    }

    function groupId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return `pwyw-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }

    function initialize(root) {
      if (!root || root.dataset.acPwywReady === 'true') return;

      const configNode = root.querySelector('[data-ac-pwyw-home-config]');
      if (!configNode) return;

      let config;
      try {
        config = JSON.parse(configNode.textContent);
      } catch (error) {
        const visibleStatus = root.querySelector('[data-ac-role="status"]');
        if (visibleStatus) {
          visibleStatus.textContent = 'The offer configuration could not load. Please contact the store owner.';
        }
        root.querySelectorAll('button').forEach((button) => {
          button.disabled = true;
        });
        console.error('AC PWYW configuration error:', error);
        return;
      }
      root.dataset.acPwywReady = 'true';

      const get = (role) => root.querySelector(`[data-ac-role="${role}"]`);
      const formatButtons = Array.from(root.querySelectorAll('[data-ac-format]'));
      const priceButtons = Array.from(root.querySelectorAll('[data-ac-price-choice]'));
      const vaultItems = Array.from(root.querySelectorAll('[data-ac-vault-item]'));
      const vaultNodes = Array.from(root.querySelectorAll('[data-ac-vault-node]'));
      const vaultTicks = Array.from(root.querySelectorAll('[data-ac-vault-tick]'));
      const title = get('title');
      const eyebrow = get('eyebrow');
      const description = get('description');
      const productImage = get('product-image');
      const retailPrice = get('retail-price');
      const customCard = root.querySelector('[data-ac-custom-card]');
      const customInput = get('custom-input');
      const customCardCopy = get('custom-card-copy');
      const errorMessage = get('error');
      const vaultCount = get('vault-count');
      const vaultProgress = get('vault-progress');
      const claimButton = get('claim');
      const claimLabel = get('claim-label');
      const claimPrice = get('claim-price');
      const delivery = get('delivery');
      const status = get('status');

      let selectedFormatKey = 'ebooks';
      let selectedChoice = 'indulgent';
      let selectedCents = config.formats.ebooks.tiers[1].priceCents;
      let customMode = false;
      let adding = false;

      function formatData() {
        return config.formats[selectedFormatKey];
      }

      function tierByKey(key) {
        return formatData().tiers.find((tier) => tier.key === key);
      }

      function earnedTier(amountCents) {
        return formatData().tiers
          .filter((tier) => tier.id && tier.available && amountCents >= tier.priceCents)
          .sort((a, b) => a.priceCents - b.priceCents)
          .pop() || null;
      }

      function configurationProblem() {
        if (config.currency !== 'USD') {
          return 'This first functional build checks out in USD. Please switch the store currency to USD.';
        }

        const missingTiers = formatData().tiers.some((tier) => !tier.id || !tier.available);
        if (missingTiers) {
          return 'This format is missing one or more matching, available price variants in the section settings.';
        }

        if (!config.adjustments.dollar.id || !config.adjustments.cent.id) {
          return 'Select the unlisted PWYW adjustment product in this section’s settings.';
        }

        if (!config.adjustments.dollar.available || !config.adjustments.cent.available) {
          return 'Both adjustment variants must be available for sale.';
        }

        if (config.adjustments.dollar.priceCents !== 100 || config.adjustments.cent.priceCents !== 1) {
          return 'The adjustment variants must be exactly $1.00 and $0.01 in USD.';
        }

        return '';
      }

      function customerValidation() {
        const minimum = formatData().tiers[0].priceCents;
        if (!Number.isInteger(selectedCents)) {
          return `Enter a price using no more than two decimal places.`;
        }
        if (selectedCents < minimum) {
          return `The minimum for this format is ${money(minimum, config.currency)}.`;
        }
        if (selectedCents > config.maximumCustomCents) {
          return `For this test build, the maximum custom price is ${money(config.maximumCustomCents, config.currency)}.`;
        }
        return '';
      }

      function currentValidation() {
        const customerProblem = customerValidation();
        if (customerProblem) return customerProblem;
        if (!earnedTier(selectedCents)) {
          return 'The matching entitlement variant is unavailable.';
        }
        return configurationProblem();
      }

      function renderVault() {
        const tier = earnedTier(selectedCents);
        const unlocked = tier ? formatData().tiers.findIndex((item) => item.key === tier.key) + 1 : 0;
        vaultCount.textContent = `Clout level ${unlocked}/3`;
        vaultProgress.style.width = `${unlocked <= 1 ? 0 : ((unlocked - 1) / 2) * 100}%`;
        vaultNodes.forEach((node, index) => {
          node.classList.toggle('is-unlocked', index < unlocked);
        });
        vaultTicks.forEach((tick, index) => {
          tick.classList.toggle('is-unlocked', unlocked >= index + 2);
        });
        vaultItems.forEach((item, index) => {
          item.classList.toggle('is-unlocked', index < unlocked);
        });
      }

      function render() {
        const product = formatData();
        const retail = product.tiers[2].priceCents;
        const validation = currentValidation();
        const customerMessage = customerValidation();
        const hasPrice = Number.isInteger(selectedCents);

        formatButtons.forEach((button) => {
          button.setAttribute('aria-selected', String(button.dataset.acFormat === selectedFormatKey));
        });

        priceButtons.forEach((button) => {
          const key = button.dataset.acPriceChoice;
          const isCustom = key === 'custom';
          const tier = isCustom ? null : tierByKey(key);
          const selected = isCustom ? customMode : !customMode && key === selectedChoice;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
          button.disabled = isCustom ? false : !tier || !tier.id || !tier.available;
          const value = button.querySelector(`[data-ac-price-value="${key}"]`);
          if (value && tier) value.textContent = money(tier.priceCents, config.currency);
        });
        customCard.classList.toggle('is-selected', customMode);

        title.textContent = product.title;
        eyebrow.textContent = product.eyebrow;
        description.textContent = product.description;
        retailPrice.textContent = money(retail, config.currency);
        const minimum = product.tiers[0].priceCents;
        const minimumAmount = (minimum / 100).toFixed(2);
        const minimumPrompt = `${minimumAmount} minimum`;
        customInput.placeholder = customMode
          ? minimumPrompt
          : '';
        customInput.setAttribute('aria-label', `Your custom price in US dollars. Minimum ${money(minimum, config.currency)}.`);
        claimLabel.textContent = customMode && !hasPrice ? config.labels.enterPrice : product.claim;
        claimPrice.textContent = hasPrice ? money(selectedCents, config.currency) : config.labels.yourPrice;
        delivery.textContent = product.delivery;
        customCardCopy.textContent = customMode ? 'Support indie authors ♥' : product.customCopy;

        if (product.image) {
          productImage.src = product.image;
          productImage.alt = product.title;
        } else {
          productImage.removeAttribute('src');
          productImage.alt = '';
        }

        const hasCustomText = customInput.value.trim() !== '';
        errorMessage.hidden = !customerMessage || (customMode && !hasCustomText);
        errorMessage.textContent = customerMessage;
        claimButton.disabled = Boolean(validation) || adding;
        renderVault();
      }

      function chooseFormat(key) {
        selectedFormatKey = key;
        selectedChoice = 'indulgent';
        selectedCents = formatData().tiers[1].priceCents;
        customMode = false;
        customInput.value = '';
        status.textContent = '';
        render();
      }

      formatButtons.forEach((button) => {
        button.addEventListener('click', () => chooseFormat(button.dataset.acFormat));
      });

      function activateCustomPrice() {
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        customMode = true;
        status.textContent = '';
        render();
        window.requestAnimationFrame(() => customInput.focus());
      }

      priceButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const key = button.dataset.acPriceChoice;
          if (key === 'custom') {
            activateCustomPrice();
            return;
          }

          const tier = tierByKey(key);
          if (!tier || !tier.id || !tier.available) return;
          selectedChoice = tier.key;
          selectedCents = tier.priceCents;
          customMode = false;
          customInput.value = '';
          status.textContent = '';
          render();
        });
      });

      customCard.addEventListener('click', (event) => {
        if (event.target.closest('[data-ac-price-choice="custom"]')) return;
        activateCustomPrice();
      });

      customInput.addEventListener('focus', () => {
        if (customMode) return;
        customMode = true;
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        status.textContent = '';
        render();
      });

      customInput.addEventListener('input', () => {
        customMode = true;
        selectedChoice = 'custom';
        selectedCents = parseMoneyToCents(customInput.value);
        status.textContent = '';
        render();
      });

      customInput.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.isComposing) return;
        event.preventDefault();
        claimButton.click();
      });

      claimButton.addEventListener('click', async () => {
        if (adding) return;
        const validation = currentValidation();
        if (validation) {
          render();
          return;
        }

        const product = formatData();
        const tier = earnedTier(selectedCents);
        const parentPriceCents = Number.isInteger(tier.basePriceCents) ? tier.basePriceCents : tier.priceCents;
        const differenceCents = selectedCents - parentPriceCents;
        const dollarQuantity = Math.floor(differenceCents / 100);
        const centQuantity = differenceCents % 100;
        const purchaseGroup = groupId();
        const chosenPrice = `${money(selectedCents, config.currency)} ${config.currency}`;
        const accessLabels = {
          minimum: 'Complete Collection',
          indulgent: 'Certified Enabler',
          retail: 'Full Bonus Vault'
        };
        const accessLabel = accessLabels[tier.key] || 'Complete Collection';
        const items = [
          {
            id: Number(tier.id),
            quantity: 1,
            properties: {
              'Your price': chosenPrice,
              'Access': accessLabel,
              '_pwyw': 'true',
              '_pwyw_group': purchaseGroup,
              '_pwyw_format': selectedFormatKey,
              '_pwyw_tier': tier.key,
              '_pwyw_total_cents': String(selectedCents)
            }
          }
        ];

        if (dollarQuantity > 0) {
          items.push({
            id: Number(config.adjustments.dollar.id),
            quantity: dollarQuantity,
            parent_id: Number(tier.id),
            properties: {
              '_pwyw_adjustment': 'dollar',
              '_pwyw_group': purchaseGroup,
              '_pwyw_parent_variant_id': String(tier.id)
            }
          });
        }

        if (centQuantity > 0) {
          items.push({
            id: Number(config.adjustments.cent.id),
            quantity: centQuantity,
            parent_id: Number(tier.id),
            properties: {
              '_pwyw_adjustment': 'cent',
              '_pwyw_group': purchaseGroup,
              '_pwyw_parent_variant_id': String(tier.id)
            }
          });
        }

        adding = true;
        claimButton.disabled = true;
        claimLabel.textContent = 'Building your order…';
        status.textContent = '';

        const storeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

        try {
          const response = await fetch(`${storeRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          });
          const payload = await response.json();

          if (!response.ok) {
            throw new Error(payload.description || payload.message || 'Shopify could not add this offer to the cart.');
          }

          status.textContent = 'Offer added. Opening secure checkout…';
          const destination = config.destination === 'cart' ? 'cart' : 'checkout';
          window.location.assign(`${storeRoot}${destination}`);
        } catch (error) {
          adding = false;
          status.textContent = error && error.message
            ? error.message
            : 'Something interrupted the cart. Please try once more.';
          render();
        }
      });

      render();
    }

    function initializeAll(scope) {
      const container = scope || document;
      if (container.matches && container.matches(SELECTOR)) initialize(container);
      container.querySelectorAll(SELECTOR).forEach(initialize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["addison-cain-pwyw-split-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
const SELECTOR = '[data-ac-pwyw-home]';
function money(cents, currency) {
return new Intl.NumberFormat('en-US', {
style: 'currency',
currency: currency || 'USD'
}).format(cents / 100);
}
function parseMoneyToCents(rawValue) {
const cleaned = String(rawValue || '').trim().replace(/[$\s]/g, '').replace(',', '.');
if (!/^\d+(?:\.\d{0,2})?$/.test(cleaned)) return null;
const parts = cleaned.split('.');
const whole = Number(parts[0]);
const fraction = Number((parts[1] || '').padEnd(2, '0'));
if (!Number.isSafeInteger(whole) || whole < 0) return null;
return (whole * 100) + fraction;
}
function groupId() {
if (window.crypto && typeof window.crypto.randomUUID === 'function') {
return window.crypto.randomUUID();
}
return `pwyw-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
function initialize(root) {
if (!root || root.dataset.acPwywReady === 'true') return;
const configNode = root.querySelector('[data-ac-pwyw-home-config]');
if (!configNode) return;
let config;
try {
config = JSON.parse(configNode.textContent);
} catch (error) {
const visibleStatus = root.querySelector('[data-ac-role="status"]');
if (visibleStatus) {
visibleStatus.textContent = 'The offer configuration could not load. Please contact the store owner.';
}
root.querySelectorAll('button').forEach((button) => {
button.disabled = true;
});
console.error('AC PWYW configuration error:', error);
return;
}
root.dataset.acPwywReady = 'true';
const get = (role) => root.querySelector(`[data-ac-role="${role}"]`);
const formatButtons = Array.from(root.querySelectorAll('[data-ac-format]'));
const priceButtons = Array.from(root.querySelectorAll('[data-ac-price-choice]'));
const vaultItems = Array.from(root.querySelectorAll('[data-ac-vault-item]'));
const vaultNodes = Array.from(root.querySelectorAll('[data-ac-vault-node]'));
const vaultTicks = Array.from(root.querySelectorAll('[data-ac-vault-tick]'));
const title = get('title');
const eyebrow = get('eyebrow');
const description = get('description');
const productImage = get('product-image');
const retailPrice = get('retail-price');
const customCard = root.querySelector('[data-ac-custom-card]');
const customInput = get('custom-input');
const customCardCopy = get('custom-card-copy');
const errorMessage = get('error');
const vaultCount = get('vault-count');
const vaultProgress = get('vault-progress');
const selectionTotal = get('selection-total');
const claimButton = get('claim');
const claimLabel = get('claim-label');
const claimPrice = get('claim-price');
const delivery = get('delivery');
const status = get('status');
let selectedFormatKey = 'ebooks';
let selectedChoice = 'indulgent';
let selectedCents = config.formats.ebooks.tiers[1].priceCents;
let customMode = false;
let adding = false;
function formatData() {
return config.formats[selectedFormatKey];
}
function tierByKey(key) {
return formatData().tiers.find((tier) => tier.key === key);
}
function minimumPriceCents() {
const tier = formatData().tiers[0];
return Math.max(Number(tier.priceCents) || 0, Number(tier.basePriceCents) || 0);
}
function earnedTier(amountCents) {
return formatData().tiers
.filter((tier) => tier.id && tier.available && amountCents >= tier.priceCents)
.sort((a, b) => a.priceCents - b.priceCents)
.pop() || null;
}
function configurationProblem() {
if (config.currency !== 'USD') {
return 'This first functional build checks out in USD. Please switch the store currency to USD.';
}
const missingTiers = formatData().tiers.some((tier) => !tier.id || !tier.available);
if (missingTiers) {
return 'This format is missing one or more matching, available price variants in the section settings.';
}
if (!config.adjustments.dollar.id || !config.adjustments.cent.id) {
return 'Select the unlisted PWYW adjustment product in this section’s settings.';
}
if (!config.adjustments.dollar.available || !config.adjustments.cent.available) {
return 'Both adjustment variants must be available for sale.';
}
if (config.adjustments.dollar.priceCents !== 100 || config.adjustments.cent.priceCents !== 1) {
return 'The adjustment variants must be exactly $1.00 and $0.01 in USD.';
}
return '';
}
function customerValidation() {
const minimum = minimumPriceCents();
if (!Number.isInteger(selectedCents)) {
return `Enter a price using no more than two decimal places.`;
}
if (selectedCents < minimum) {
return `The minimum for this format is ${money(minimum, config.currency)}.`;
}
if (selectedCents > config.maximumCustomCents) {
return `The maximum custom price is ${money(config.maximumCustomCents, config.currency)}.`;
}
return '';
}
function currentValidation() {
const customerProblem = customerValidation();
if (customerProblem) return customerProblem;
if (!earnedTier(selectedCents)) {
return 'The matching entitlement variant is unavailable.';
}
return configurationProblem();
}
function renderVault() {
const tier = earnedTier(selectedCents);
const unlocked = tier ? formatData().tiers.findIndex((item) => item.key === tier.key) + 1 : 0;
vaultCount.textContent = `Clout level ${unlocked}/3`;
vaultProgress.style.width = `${unlocked <= 1 ? 0 : ((unlocked - 1) / 2) * 100}%`;
vaultNodes.forEach((node, index) => {
node.classList.toggle('is-unlocked', index < unlocked);
});
vaultTicks.forEach((tick, index) => {
tick.classList.toggle('is-unlocked', unlocked >= index + 2);
});
vaultItems.forEach((item, index) => {
item.classList.toggle('is-unlocked', index < unlocked);
});
}
function render() {
const product = formatData();
const retail = product.tiers[2].priceCents;
const validation = currentValidation();
const customerMessage = customerValidation();
const hasPrice = Number.isInteger(selectedCents);
const hasCustomText = customInput.value.trim() !== '';
formatButtons.forEach((button) => {
button.setAttribute('aria-selected', String(button.dataset.acFormat === selectedFormatKey));
});
priceButtons.forEach((button) => {
const key = button.dataset.acPriceChoice;
const isCustom = key === 'custom';
const tier = isCustom ? null : tierByKey(key);
const selected = isCustom ? customMode : !customMode && key === selectedChoice;
button.classList.toggle('is-selected', selected);
button.setAttribute('aria-pressed', String(selected));
button.disabled = isCustom ? false : !tier || !tier.id || !tier.available;
const value = button.querySelector(`[data-ac-price-value="${key}"]`);
if (value && tier) value.textContent = money(tier.priceCents, config.currency);
});
customCard.classList.toggle('is-selected', customMode);
title.textContent = product.title;
eyebrow.textContent = product.eyebrow;
description.textContent = product.description;
retailPrice.textContent = money(retail, config.currency);
const minimum = minimumPriceCents();
const minimumAmount = (minimum / 100).toFixed(2);
const minimumPrompt = `${minimumAmount} minimum`;
const parsedCustomCents = parseMoneyToCents(customInput.value);
const belowMinimum = customMode && Number.isInteger(parsedCustomCents) && parsedCustomCents < minimum;
customInput.placeholder = customMode
? minimumPrompt
: '';
customInput.setAttribute('aria-label', `Your custom price in US dollars. Minimum ${money(minimum, config.currency)}.`);
claimLabel.textContent = customMode && !hasPrice ? config.labels.enterPrice : product.claim;
claimPrice.textContent = hasPrice ? money(selectedCents, config.currency) : config.labels.yourPrice;
selectionTotal.textContent = hasPrice ? money(selectedCents, config.currency) : config.labels.yourPrice;
selectionTotal.parentElement.hidden = customMode && (!hasPrice || Boolean(customerMessage));
delivery.textContent = product.delivery;
customCard.classList.toggle('is-below-minimum', belowMinimum);
if (!customMode) {
customCardCopy.textContent = product.customCopy;
} else if (belowMinimum) {
customCardCopy.textContent = `Minimum ${money(minimum, config.currency)} — support indie authors ♥`;
} else if (customerMessage && hasCustomText) {
customCardCopy.textContent = customerMessage;
} else {
customCardCopy.textContent = 'Support indie authors ♥';
}
if (product.image) {
productImage.src = product.image;
productImage.alt = product.title;
} else {
productImage.removeAttribute('src');
productImage.alt = '';
}
errorMessage.hidden = true;
errorMessage.textContent = '';
claimButton.disabled = Boolean(validation) || adding;
renderVault();
}
function chooseFormat(key) {
selectedFormatKey = key;
selectedChoice = 'indulgent';
selectedCents = formatData().tiers[1].priceCents;
customMode = false;
customInput.value = '';
status.textContent = '';
render();
}
formatButtons.forEach((button) => {
button.addEventListener('click', () => chooseFormat(button.dataset.acFormat));
});
function activateCustomPrice() {
selectedChoice = 'custom';
selectedCents = parseMoneyToCents(customInput.value);
customMode = true;
status.textContent = '';
render();
window.requestAnimationFrame(() => customInput.focus());
}
priceButtons.forEach((button) => {
button.addEventListener('click', () => {
const key = button.dataset.acPriceChoice;
if (key === 'custom') {
activateCustomPrice();
return;
}
const tier = tierByKey(key);
if (!tier || !tier.id || !tier.available) return;
selectedChoice = tier.key;
selectedCents = tier.priceCents;
customMode = false;
customInput.value = '';
status.textContent = '';
render();
});
});
customCard.addEventListener('click', (event) => {
if (event.target.closest('[data-ac-price-choice="custom"]')) return;
activateCustomPrice();
});
customInput.addEventListener('focus', () => {
if (customMode) return;
customMode = true;
selectedChoice = 'custom';
selectedCents = parseMoneyToCents(customInput.value);
status.textContent = '';
render();
});
customInput.addEventListener('input', () => {
customMode = true;
selectedChoice = 'custom';
selectedCents = parseMoneyToCents(customInput.value);
status.textContent = '';
render();
});
customInput.addEventListener('keydown', (event) => {
if (event.key !== 'Enter' || event.isComposing) return;
event.preventDefault();
claimButton.click();
});
claimButton.addEventListener('click', async () => {
if (adding) return;
const validation = currentValidation();
if (validation) {
render();
return;
}
const product = formatData();
const tier = earnedTier(selectedCents);
const parentPriceCents = Number.isInteger(tier.basePriceCents) ? tier.basePriceCents : tier.priceCents;
const differenceCents = selectedCents - parentPriceCents;
const dollarQuantity = Math.floor(differenceCents / 100);
const centQuantity = differenceCents % 100;
const purchaseGroup = groupId();
const chosenPrice = `${money(selectedCents, config.currency)} ${config.currency}`;
const accessLabels = {
minimum: 'Complete Collection',
indulgent: 'Certified Enabler',
retail: 'Full Bonus Vault'
};
const accessLabel = accessLabels[tier.key] || 'Complete Collection';
const items = [
{
id: Number(tier.id),
quantity: 1,
properties: {
'Your price': chosenPrice,
'Access': accessLabel,
'_pwyw': 'true',
'_pwyw_group': purchaseGroup,
'_pwyw_format': selectedFormatKey,
'_pwyw_tier': tier.key,
'_pwyw_total_cents': String(selectedCents)
}
}
];
if (dollarQuantity > 0) {
items.push({
id: Number(config.adjustments.dollar.id),
quantity: dollarQuantity,
parent_id: Number(tier.id),
properties: {
'_pwyw_adjustment': 'dollar',
'_pwyw_group': purchaseGroup,
'_pwyw_parent_variant_id': String(tier.id)
}
});
}
if (centQuantity > 0) {
items.push({
id: Number(config.adjustments.cent.id),
quantity: centQuantity,
parent_id: Number(tier.id),
properties: {
'_pwyw_adjustment': 'cent',
'_pwyw_group': purchaseGroup,
'_pwyw_parent_variant_id': String(tier.id)
}
});
}
adding = true;
claimButton.disabled = true;
claimLabel.textContent = 'Building your order…';
status.textContent = '';
const storeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
? window.Shopify.routes.root
: '/';
try {
const response = await fetch(`${storeRoot}cart/add.js`, {
method: 'POST',
headers: {
'Accept': 'application/json',
'Content-Type': 'application/json'
},
body: JSON.stringify({ items })
});
const payload = await response.json();
if (!response.ok) {
throw new Error(payload.description || payload.message || 'Shopify could not add this offer to the cart.');
}
status.textContent = 'Offer added. Opening secure checkout…';
const destination = config.destination === 'cart' ? 'cart' : 'checkout';
window.location.assign(`${storeRoot}${destination}`);
} catch (error) {
adding = false;
status.textContent = error && error.message
? error.message
: 'Something interrupted the cart. Please try once more.';
render();
}
});
render();
}
function initializeAll(scope) {
const container = scope || document;
if (container.matches && container.matches(SELECTOR)) initialize(container);
container.querySelectorAll(SELECTOR).forEach(initialize);
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
} else {
initializeAll(document);
}
document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    function renderLogoMobile() {
        if ($("[data-menu-tab]").length > 0) {

            $(document).on("click", "[data-menu-tab] li", (event) => {
                var active = $(event.currentTarget).data("load-page"),
                    href = $(event.currentTarget).attr("href");

                $.cookie("page-url", active, {
                    expires: 1,
                    path: "/",
                });
            });

            var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
            pageUrl = $.cookie("page-url"),
            menuTabItem,
            logoTabItem,
            menuItem;

            if (
                window.location.pathname.indexOf("/pages/") !== -1 &&
                window.page_active &&
                window.page_active != pageUrl
            ) {
                setCookie("page-url", window.page_active, 1);
                pageUrl = window.page_active;
            }
            
            if (pageUrl != null) {
                menuTabItem = $(`[data-load-page="${pageUrl}"]`);
                logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
                menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
            } else {
                menuTabItem = $("[data-load-page].is-active");
                logoTabItem = $("[data-load-logo-page].first");
                menuItem = $("[data-load-menu-page].is-active");
            }

            var menuTab = menuTabItem.closest("[data-menu-tab]");

            menuTab
                .find("[data-load-page]")
                .not(menuTabItem)
                .removeClass("is-active");
                logoTabItem.siblings().removeClass("is-active");
                menuItem.siblings().removeClass("is-active");
            if (pageUrl != "") {
                logoTabItem.addClass("is-active");
                menuTabItem.addClass("is-active");
                menuItem.addClass("is-active");
            } else {
                $("[data-load-page]:nth-child(1)").addClass("is-active");
                $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
                $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
            }

            const header = menuTabItem.closest(".header");

            
            if (header && window.innerWidth < 1025) {
                if (
                    window.location.pathname.indexOf("/pages/") !== -1 &&
                    window.page_active &&
                    window.page_active != pageUrl
                ) {
                    setCookie("page-url", window.page_active, 1);
                    pageUrl = window.page_active;
                }

                const logoMobile = $(".header-mobile .header__heading-link");
                const logDesktop = header.find(".header__heading-link.is-active");

                if (logDesktop.data("logo-mobile") == undefined) {
                    logoMobile.find("img").addClass("logo-show");
                    return;
                } else {
                    logoMobile.html(
                    `<img src="${logDesktop.data(
                        "logo-mobile"
                    )}" alt="${logDesktop.data(
                        "logo-mobile-alt"
                    )}" style="max-width: ${logoMobile.data(
                        "logo-width"
                    )}px; height: auto"/>`
                    );

                    logoMobile.find("img").addClass("logo-show");
                    if (pageUrl != "" && pageUrl != null)
                    logoMobile.attr("href", pageUrl);
                }
            }
        }
    }

    renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    document.addEventListener('DOMContentLoaded', () => {customElements.define('sticky-header', StickyHeader)});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('load', this.checkLoadPosition.bind(this));
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('load', this.checkLoadPosition);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        checkLoadPosition() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

            if(headerGr[0].classList.contains('shopify-section-header-sticky')) {
                if(scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains('scrolled-past-header')) {
                    this.header.classList.add('shopify-section-header-hidden');
                }
            } else {
                headerGr.forEach(item => {
                    if(item.classList.contains('shopify-section-header-sticky') ) {
                        const itemPrev = item.previousElementSibling;
                        const itemPrevHeight = itemPrev.offsetHeight;
                        const itemPrevTop = itemPrev.offsetTop;

                        if(scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains('scrolled-past-header')) {
                            this.header.classList.add('shopify-section-header-hidden');
                        }
                    }
                });
            }
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                    document.querySelector('body').classList.add("section-header-is-hidden")
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('scrolled-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
              if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                  if (document.body.classList.contains('template-index')) {
                      if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
                          $('.vertical-menu').removeClass('vertical-menu__hide');
                      }
                  }
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();
})();
